<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("add") }} {{ $t("promotionsandoffer") }}
      </div>
      <router-link class="btn-blue" to="promotions-and-offers"
        >{{ $t("promotionsandoffer") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <!-- BOX 1 -->

      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-11"
            style="padding: 6px; align-items: center"
            v-b-toggle.offer
          >
            <span class="fs">Offer</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <div class="col-1 align-self-center">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="OffersAndPromotion.os_is_active"
                name="check-button"
                class="j-checkbox pb-0"
              ></b-form-checkbox>
              <label class="mb-0 mr-2">{{ $t("active") }}</label>
            </div>
          </div>
        </div>

        <b-collapse id="offer" v-model="sectionCollapse.offer">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="d-flex back_white px-0 mx-3 pt-2 mb-3 flex-wrap">
                <div class="col-lg-6 col-xl-2 mb-2">
                  <div class="input-material">
                    <input
                      v-model="OffersAndPromotion.offer_title"
                      name="offer_title"
                      id="offer_title"
                      v-validate="'required'"
                      placeholder="."
                      type="text"
                      @input="onChangeText($event, 'name')"
                    />
                    <label>{{ $t("title") }}</label>
                  </div>
                  <p
                    v-if="submitted && errors.has('offer_title')"
                    class="error_message"
                  >
                    <span>{{ errors.first("offer_title") }}</span>
                  </p>
                </div>
                <div class="col-lg-6 col-xl-2 mb-2">
                  <div class="input-material">
                    <input
                      disabled
                      v-model="OffersAndPromotion.offer_code"
                      placeholder="."
                      type="text"
                    />
                    <label>{{ $t("code") }}</label>
                  </div>
                </div>

                <!-- {{ OffersAndPromotion.offer_start_date_time }} -->
                <div class="col-lg-6 col-xl-2 mb-2">
                  <div class="input-material">
                    <div class="add-datepicker custom-date">
                      <!-- <datetime
                  v-model="OffersAndPromotion.offer_start_date_time"
                  type="date"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd"
                  use12-hour
                ></datetime> -->
                      <button
                        style="right: 7px !important"
                        class="btn-clearDate"
                        v-if="OffersAndPromotion.offer_start_date_time"
                        v-on:click="
                          OffersAndPromotion.offer_start_date_time = null
                        "
                      >
                        ✖
                      </button>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="OffersAndPromotion.offer_start_date_time"
                          type="date"
                          class="theme-custom-date-time"
                          typeable
                          v-validate="'required'"
                          v-b-tooltip.hover
                          :title="$t('offer_start_date_tooltip')"
                        >
                        </Datepicker>
                        <!--Tooltip :title="$t('offer_start_date_tooltip')" /-->
                      </div>
                      <!-- <Datepicker :monday-first="true"  ref="programaticOpen" name="fdate" id="fdate" v-validate="'required'"></Datepicker> -->
                      <label
                        :class="
                          OffersAndPromotion.offer_start_date_time
                            ? 'active'
                            : ''
                        "
                        >{{ $t("startdate") }}</label
                      >
                    </div>
                  </div>
                </div>
                <!-- {{ OffersAndPromotion.offer_end_date_time }} -->
                <div class="col-lg-6 col-xl-2 mb-2">
                  <div class="input-material">
                    <div class="add-datepicker custom-date">
                      <!-- <datetime
                  v-model="OffersAndPromotion.offer_end_date_time"
                  type="date"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd"
                  use12-hour
                ></datetime> -->
                      <button
                        style="right: 7px !important"
                        class="btn-clearDate"
                        v-if="OffersAndPromotion.offer_end_date_time"
                        v-on:click="
                          OffersAndPromotion.offer_end_date_time = null
                        "
                      >
                        ✖
                      </button>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="OffersAndPromotion.offer_end_date_time"
                          type="date"
                          class="theme-custom-date-time"
                          typeable
                          v-validate="'required'"
                          v-b-tooltip.hover
                          :title="$t('offer_end_date_tooltip')"
                        >
                        </Datepicker>
                        <!--Tooltip :title="$t('offer_end_date_tooltip')" /-->
                      </div>
                      <!-- <Datepicker :monday-first="true"  ref="programaticOpen" name="fdate" id="fdate" v-validate="'required'"></Datepicker> -->
                      <label
                        :class="
                          OffersAndPromotion.offer_end_date_time ? 'active' : ''
                        "
                        >{{ $t("offer") }} {{ $t("enddate") }}</label
                      >
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-xl-2 mb-2 custom-timepicker">
                  <div class="d-flex justify-content-center align-items-center">
                    <vue-timepicker
                      manual-input
                      v-model="OffersAndPromotion.startTime2"
                      id="starttime"
                      name="starttime"
                      :placeholder="$tc('starttime')"
                      format="HH:mm"
                      class="time_picker"
                      input-width="100%"
                      auto-scroll
                      lazy
                      v-b-tooltip.hover
                      :title="$t('offer_start_time')"
                    ></vue-timepicker>
                    <!--Tooltip :title="$t('offer_start_time')" /-->
                  </div>
                  <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                  v-model="OffersAndPromotion.offer_start_date_time"
                  type="time"
                  class="theme-custom-date-time"
                  format="hh:mm a"
                  use12-hour
                  lang="en"
                  :minute-step="1"
                  typeable
                  v-validate="'required'"
                  id="o_start_time"
                ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("starttime") }}</label
                >
              </div>
            </div> -->
                </div>

                <div class="col-lg-6 col-xl-2 mb-2 custom-timepicker">
                  <div class="d-flex justify-content-center align-items-center">
                    <vue-timepicker
                      manual-input
                      v-model="OffersAndPromotion.endTime2"
                      id="endtime"
                      name="endtime"
                      :placeholder="$tc('endtime')"
                      format="HH:mm"
                      class="time_picker"
                      input-width="100%"
                      auto-scroll
                      lazy
                      v-b-tooltip.hover
                      :title="$t('offer_end_time')"
                    ></vue-timepicker>
                    <!--Tooltip :title="$t('offer_end_time')" /-->
                  </div>
                  <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                  v-model="OffersAndPromotion.offer_end_date_time"
                  type="time"
                  class="theme-custom-date-time"
                  format="hh:mm a"
                  use12-hour
                  lang="en"
                  :minute-step="1"
                  typeable
                  v-validate="'required'"
                  id="o_end_time"
                ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("endtime") }}</label
                >
              </div>
            </div> -->
                </div>
                <div class="col-lg-6 col-xl-2 my-3">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        selectedOfferGroupType.hasOwnProperty('ogt_id')
                          ? 'shift-up'
                          : ''
                      "
                      >Offer Group Type</label
                    >
                    <div class>
                      <!-- v-model="OfferConfiguraion.cine_id" -->
                      <!-- @input="getScreenList" -->

                      <multiselect
                        v-model="selectedOfferGroupType"
                        :options="offerGroupType"
                        placeholder="Select Offer Group"
                        label="ogt_type_name"
                        :multiple="false"
                        track-by="ogt_id"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-xl-4 my-3">
                  <div class="input-material">
                    <input
                      v-model="OffersAndPromotion.offer_description_text"
                      placeholder="."
                      type="text"
                    />
                    <label>{{ $t("description") }}</label>
                  </div>
                </div>
                <!-- client_id -->
                <!-- <div class="col-lg-6 col-xl-3 mb-4">
            <multiselect
              v-model="OffersAndPromotion.selectedClient"
              placeholder="Select Client"
              :options="clientList"
              @select="onSelectClient($event)"
              label="client_name"
              track-by="client_id"
              :multiple="false"
            ></multiselect>
          </div>-->
              </div>

              <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
                <div class="bn-tabs-nav mb-2">
                  <button
                    v-for="(Content, ContentIndex) in offerContent"
                    :key="ContentIndex"
                    :class="[
                      'btn-tab-title',
                      { active: ContentIndex == activeClass },
                    ]"
                    @click.prevent.stop="
                      onChangeTabHandler($event, ContentIndex)
                    "
                  >
                    <strong>
                      <span
                        :class="
                          Content.langauge.toLowerCase() !== 'english'
                            ? notempty[ContentIndex]
                              ? ''
                              : 'text-danger'
                            : ''
                        "
                        >{{ Content.langauge }}</span
                      >
                    </strong>
                  </button>
                </div>
                <div class="bn-tabs-content">
                  <div
                    v-for="(Content, ContentIndex) in offerContent"
                    :key="ContentIndex"
                  >
                    <div v-if="ContentIndex === activeClass">
                      <div class="row">
                        <div class="col-lg-6 col-xl-4 align-self-center">
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="."
                                type="text"
                                v-model="Content.offer_title"
                                name="offer_content_title"
                                id="offer_content_title"
                                @input="
                                  CheckEmptyContent(Content, ContentIndex)
                                "
                                v-validate="
                                  Content.langauge.toLowerCase() === 'english'
                                    ? 'required'
                                    : ''
                                "
                                v-b-tooltip.hover
                                :title="$t('offer_content_title')"
                              />
                              <label
                                >{{ $t("offer") }} {{ $t("title") }} ({{
                                  $t("optional")
                                }})</label
                              >
                            </div>
                            <!--Tooltip :title="$t('offer_content_title')" /-->
                          </div>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted && errors.has('offer_content_title')
                              "
                              >{{ errors.first("offer_content_title") }}</span
                            >
                          </p>
                          <!--p
                        v-if="Content.langauge.toLowerCase() !== 'english'"
                        class="fs-12"
                      >
                        ({{ $t("optional") }})
                      </p-->
                        </div>

                        <div
                          class="col-lg-6 col-xl-6 align-self-center"
                          v-if="false"
                        >
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <input
                                placeholder="."
                                type="text"
                                v-model="Content.offer_description"
                                name="offer_content_desc"
                                id="offer_content_desc"
                                @input="
                                  CheckEmptyContent(Content, ContentIndex)
                                "
                                v-b-tooltip.hover
                                :title="$t('offer_content_desc')"
                              />
                              <label
                                >{{ $t("description") }} ({{
                                  $t("optional")
                                }})</label
                              >
                            </div>
                            <!--Tooltip :title="$t('offer_content_desc')" /-->
                          </div>
                          <p class="error_message">
                            <span v-if="submitted && errors.has('offerdesc')">{{
                              errors.first("offerdesc")
                            }}</span>
                          </p>
                          <!--p
                        v-if="Content.langauge.toLowerCase() !== 'english'"
                        class="fs-12"
                      >
                        ({{ $t("optional") }})
                      </p-->
                        </div>

                        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                          <div class="row align-self-center">
                            <div class="col-10">
                              <label
                                class="material-file-upload"
                                @click.prevent.stop="
                                  setModalData(
                                    banner_image_height,
                                    banner_image_width,
                                    ContentIndex,
                                    1
                                  )
                                "
                              >
                                <div class="label"></div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate">
                                    {{
                                      Content.offer_banner_image
                                        ? Content.offer_banner_image
                                        : "Offer Banner Image"
                                    }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div class="col-1 mt-1">
                              <img
                                width="40"
                                height="40"
                                class="rounded c-pointer img-preview"
                                @click="
                                  openImageModal('', Content.offer_banner_image)
                                "
                                :src="_GetImagePath(Content.offer_banner_image)"
                                v-if="Content.offer_banner_image"
                              />
                              <img
                                v-else
                                width="35"
                                height="35"
                                class="rounded"
                                alt="Empty Image"
                                src="@/assets/img/icons/empty-image.svg"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                          <div class="row align-self-center">
                            <div class="col-10">
                              <label
                                class="material-file-upload"
                                @click.prevent.stop="
                                  setModalData(
                                    poster_image_height,
                                    poster_image_width,
                                    ContentIndex,
                                    2
                                  )
                                "
                              >
                                <div class="label"></div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate">
                                    {{
                                      Content.offer_poster_image
                                        ? Content.offer_poster_image
                                        : "Offer Poster Image"
                                    }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div class="col-1 mt-1">
                              <img
                                width="40"
                                height="40"
                                class="rounded c-pointer img-preview"
                                @click="
                                  openImageModal('', Content.offer_poster_image)
                                "
                                :src="_GetImagePath(Content.offer_poster_image)"
                                v-if="Content.offer_poster_image"
                              />
                              <img
                                v-else
                                width="35"
                                height="35"
                                class="rounded"
                                alt="Empty Image"
                                src="@/assets/img/icons/empty-image.svg"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-lg-12 align-self-center mb-4 descriptionEditor"
                        >
                          <div
                            class="descriptionSection font-weight-bold fs-14 mb-3"
                          >
                            Description
                          </div>
                          <div class="" v-if="isEdit">
                            <vue-editor
                              v-model="Content.offer_description"
                              name="page"
                              id="page"
                            ></vue-editor>
                          </div>
                          <div
                            class="input-material-textarea"
                            v-else-if="isEditHtml && !isEdit"
                          >
                            <textarea
                              id="htmlContent"
                              name="htmlContent"
                              @input="
                                onChangeTranslationInput(
                                  $event,
                                  Content,
                                  ContentIndex,
                                  'offer_description'
                                )
                              "
                              v-model="Content.offer_description"
                              placeholder="Description"
                              class="htmlContent"
                            />
                          </div>
                          <div class="ql-snow" v-else>
                            <div
                              class="ql-editor"
                              v-html="Content.offer_description"
                              v-if="Content.offer_description"
                            >
                            </div>
                            <div
                              class="ql-editor text-center"
                              v-else
                              style="min-height: 33px"
                            >
                              No Content
                            </div>
                          </div>
                          <vue-editor style="display: none" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div
              class=" col-md-12 new-border rounded-10 back"
              style="display:flex;flex-wrap:wrap;padding:6px 0px;"
            >
              <div
                class="col-md-5 col-lg-3 mb-3"
                v-for="(cinema, cinema_index) in cinemasList"
                :key="cinema_index"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      v-model="
                        OffersAndPromotion.pg_promo_code[cinema_index]
                          .pg_promo_code
                      "
                      :name="'pg_promo_code' + cinema_index"
                      :id="'pg_promo_code' + cinema_index"
                      placeholder="."
                      type="text"
                    />
                    <label>PG Promo - {{ cinema.cine_name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- BOX 3 -->
      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.offerconfig
        >
          <span class="fs">{{ $t("offerconfiguration") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="offerconfig" v-model="sectionCollapse.offerconfig">
          <div class="new-border rounded-10 pt-3 px-3 pb-0 mb-2 back">
            <!--div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("offerconfiguration") }}
        </div-->
            <ul class="select-offers-list">
              <li style="padiing-bottom: 6px">
                <div class="d-flex align-self-center">
                  <strong>1.&nbsp;</strong>
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OfferConfiguraion.offer_applicable_on_all_cinemas"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <div>
                    {{ $t("applicableforselectedcinemasclassesntickettypes") }}
                  </div>
                </div>
                <b-collapse
                  v-model="
                    OfferConfiguraion.offer_applicable_on_all_cinemas === 'Y'
                  "
                >
                  <div class="pt-2">
                    <div
                      v-for="(Item,
                      ItemsIndex) in selectedCinemaScreenSeatClassList"
                      :key="ItemsIndex"
                      class="row back_white mb-2 pt-2 mx-1"
                    >
                      <div class="col-lg-6 col-xl-3 mb-xl-0">
                        <custommultiselect
                          v-model="Item.cine_id"
                          :options="cinemasList"
                          @input="getScreenList($event, ItemsIndex)"
                          :placeholder="$tc('Cinemas')"
                          label="cine_name"
                          isSingleId="cine_id"
                          :multiple="false"
                          track-by="cine_id"
                        ></custommultiselect>
                      </div>

                      <div class="col-lg-6 col-xl-2 mb-xl-0">
                        <custommultiselect
                          v-model="Item.screen_id"
                          :options="
                            CinemasScreenSeatClassdataList[ItemsIndex]
                              .screenList
                          "
                          @input="getSeatClassList($event, ItemsIndex)"
                          :placeholder="$tc('screens')"
                          label="screen_name"
                          isSingleId="screen_id"
                          :multiple="false"
                          track-by="screen_id"
                        >
                        </custommultiselect>
                      </div>

                      <div class="col-lg-6 col-xl-3">
                        <custommultiselect
                          v-model="Item.sst_id"
                          :options="
                            CinemasScreenSeatClassdataList[ItemsIndex]
                              .seatClassList
                          "
                          :placeholder="$tc('Seat Class')"
                          label="sst_seat_type"
                          isSingleId="sst_id"
                          :multiple="false"
                          track-by="sst_id"
                        ></custommultiselect>
                      </div>
                      <!-- SELECT TICKET TYPE -->
                      <div class="col-md-3 mb-2">
                        <div class="d-flex align-items-center">
                          <multiselect
                            v-model="Item.tt_id"
                            @select="selectTicketType($event, ItemsIndex)"
                            :options="TicketTypes"
                            label="tt_name"
                            track-by="tt_id"
                            :placeholder="$tc('TicketType')"
                            :multiple="false"
                            v-b-tooltip.hover
                            :title="$t('selectTicketType')"
                          />
                          <!--Tooltip :title="$t('selectTicketType')" /-->
                        </div>
                      </div>
                      <!-- SELECT TICKET TYPE -->
                      <div class="col-xl-1">
                        <button
                          v-if="ItemsIndex == 0"
                          class="btn-transparent mb-3"
                          @click="addMoreCinemasScreenSeatClass()"
                        >
                          <img
                            src="@/assets/img/icons/plus.svg"
                            height="35"
                            width="35"
                          />
                        </button>

                        <!-- <button
                      v-if="ItemsIndex === 0 &&selectedCinemaScreenSeatClassList.length !== 1"
                      class="btn-transparent mb-3"
                      @click="removeCinemasScreenSeatClass(ItemsIndex)"
                    >
                      <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                    </button>-->

                        <button
                          v-if="ItemsIndex !== 0"
                          class="btn-transparent mb-3"
                          @click="removeCinemasScreenSeatClass(ItemsIndex)"
                        >
                          <img
                            src="@/assets/img/icons/minus.svg"
                            height="35"
                            width="35"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </li>

              <li>
                <div class="row mr-2 mb-2">
                  <div class="col-4">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        v-model="OffersAndPromotion.is_foreign_movie_applicable"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox pb-0"
                      ></b-form-checkbox>
                      <span class="ml-1"
                        >Is Applicable On
                        {{ showForeignMovieSection ? "Indian" : "Foreign" }}
                        Movies</span
                      >
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          selectedMovieFormats.length > 0 ? 'shift-up' : ''
                        "
                        >Applicable Movie Formats</label
                      >
                      <multiselect
                        v-model="selectedMovieFormats"
                        :options="movieFormats"
                        placeholder=""
                        label="mf_name"
                        :multiple="true"
                        track-by="mf_id"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="row mr-2 mb-2">
                  <div class="col-3 d-flex align-items-center">
                    <div>
                      <span>Movies:</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                      <b-form-radio
                        value="movies_applicable"
                        class="j-radio ml-2 pb-0"
                        v-model="offerMovies.is_applicable"
                      >
                      </b-form-radio>
                      <div>
                        <span style="text-transform:capitalize;"
                          >Applicable</span
                        >
                      </div>
                      <!---strong class="mx-3">OR</strong---->

                      <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                      <b-form-radio
                        value="movies_not_applicable"
                        class="j-radio ml-2 pb-0"
                        v-model="offerMovies.is_applicable"
                      >
                        <div>
                          <span>Not Applicable</span>
                        </div>
                      </b-form-radio>
                    </div>
                  </div>
                </div>
                <div class="row mr-2">
                  <div class="col-md-6 align-self-center pt-5">
                    <custommultiselect
                      v-model="OfferConfiguraion.selectedMovielist"
                      :options="movieList"
                      :placeholder="$t('applicableforparticularmovie')"
                      label="movie"
                      isSingleId="md_id"
                      :multiple="true"
                      track-by="md_id"
                    ></custommultiselect>
                  </div>

                  <div class="col-6 mb-2 back_white py-2">
                    <div class="mb-2">
                      {{ $t("offer_applicable_between_time") }}
                    </div>
                    <div class="d-flex">
                      <div class="col-lg-6 custom-timepicker pl-0">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <vue-timepicker
                            manual-input
                            v-model="OfferConfiguraion.pvms_start_show_time"
                            id="o_start_show_time"
                            name="o_start_show_time"
                            :placeholder="$tc('fromtime')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                            v-b-tooltip.hover
                            :title="$t('o_start_show_time')"
                          ></vue-timepicker>
                          <!--Tooltip :title="$t('o_start_show_time')" /-->
                        </div>
                        <!-- <div class="input-material">
                  <div class="add-datepicker">
                    <date-picker
                      v-model="OfferConfiguraion.pvms_start_show_time"
                      type="time"
                      class="theme-custom-date-time timepicker"
                      format="hh:mm a"
                      lang="en"
                      :minute-step="1"
                      typeable
                      v-validate="'required'"
                      id="o_start_show_time"
                    ></date-picker>
                    <label class="active"
                      >{{ $t("offer") }} {{ $t("starttime") }}</label
                    >
                  </div>
                </div> -->
                      </div>

                      <div class="col-lg-6 custom-timepicker">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <vue-timepicker
                            manual-input
                            v-model="OfferConfiguraion.pvms_end_show_time"
                            id="o_end_show_time"
                            name="o_end_show_time"
                            :placeholder="$tc('totime')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                            v-b-tooltip.hover
                            :title="$t('o_end_show_time')"
                          ></vue-timepicker>
                          <!--Tooltip :title="$t('o_end_show_time')" /-->
                        </div>
                        <!-- <div class="input-material">
                  <div class="add-datepicker">
                    <date-picker
                      v-model="OfferConfiguraion.pvms_end_show_time"
                      type="time"
                      class="theme-custom-date-time timepicker"
                      format="hh:mm a"
                      lang="en"
                      :minute-step="1"
                      v-validate="'required'"
                      id="o_end_show_time"
                    ></date-picker>
                    <label class="active"
                      >{{ $t("offer") }} {{ $t("endtime") }}</label
                    >
                  </div>
                </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <div class="px-3 pt-2">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="mb-2">{{ $t("days") }}:</div>
                      <b-form-checkbox
                        v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                        :key="weekdaysKey"
                        class="j-checkbox mx-2 mb-3"
                        @change="onChangeWeekdays($event, weekdaysKey)"
                        v-model="weekDays[weekdaysKey]"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && TrueFalseCount == 7"
                      >{{ $t("pleaseSelectAtLeastOneday") }}.</span
                    >
                  </p>
                </div>
              </div>
              <!-- <li>
            <div class="d-flex align-self-center my-3">
              <div>{{ $t("applicableontransactiontime") }}</div>
              <b-form-checkbox
                class="ml-3 mr-2"
                v-model="OfferConfiguraion.avail_on_advanced_booking"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
              <Tooltip title="If advance booking is allowed, offer date will be validated with transaction date." />
            </div>
          </li> -->
            </ul>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.offersplitconfig
        >
          <span class="fs">
            {{ $t("offer") }} {{ $t("split") }}
            {{ $tc("configuration", 1) }}</span
          >
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="offersplitconfig"
          v-model="sectionCollapse.offersplitconfig"
        >
          <div class="new-border back rounded-10 pt-3 px-3 pb-0 mb-2">
            <!--div class="section-title text-uppercase mb-4" style="font-size: 20px">
          {{ $t("offer") }} {{ $t("split") }} {{ $tc("configuration", 1) }}
        </div-->
            <!-- client_id -->

            <div class="row">
              <div class="col-lg-6 col-xl-4 mb-2">
                <multiselect
                  v-model="OffersAndPromotion.selectedClient"
                  :placeholder="$tc('Client')"
                  :options="clientList"
                  @select="onSelectClient($event)"
                  label="client_name"
                  track-by="client_id"
                  :multiple="false"
                ></multiselect>
                <!-- <p class="error_message">
            <span
              v-if="
                submitted &&
                  (!OffersAndPromotion.selectedClient ||
                    OffersAndPromotion.selectedClient.length == 0)
              "
              >Please select client.</span
            >
          </p> -->
              </div>

              <div class="col-lg-6 col-xl-4 align-self-center mb-2">
                <div class="d-flex align-items-center justify-content-center">
                  <span>{{ $t("shareValue") }}</span>
                  <div class="input-material-sm mx-2">
                    <input
                      style="text-align: right"
                      v-model="OffersAndPromotion.share_value"
                      v-validate="'decimal'"
                      name="share_value"
                      id="share_value"
                      type="text"
                    />
                  </div>
                </div>
                <p class="error_message">
                  <span v-if="errors.has('share_value')">{{
                    errors.first("share_value")
                  }}</span>
                </p>
              </div>

              <!-- IS PERCENTAGE -->
              <div class="col-lg-6 col-xl-4 mb-2">
                <div
                  class="d-flex align-items-center pt-2 justify-content-center"
                >
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.share_is_percentage"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span>{{ $t("isPercentage") }}</span>
                </div>
              </div>
            </div>
            <div class="row p-3">
              <div class="d-flex align-items-center justify-content-center">
                <span>Distributor Share Value</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="OffersAndPromotion.offer_dist_share_threshold"
                    name="dist_share_value"
                    id="dist_share_value"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.otherOfferSettings
        >
          <span class="fs">
            {{ "Other" }} {{ $t("offer") }} {{ "Settings" }}</span
          >
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="otherOfferSettings"
          v-model="sectionCollapse.otherOfferSettings"
        >
          <div class="new-border back rounded-10 px-3 pb-0 mb-2">
            <div class="row">
              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    :disabled="OffersAndPromotion.is_bank_offer == 'Y'"
                    v-model="OffersAndPromotion.is_employee_offer"
                    unchecked-value="N"
                    value="Y"
                    @change="onSelectEmployeeDiscount($event)"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">{{
                    $t("is_employee_offer")
                  }}</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.is_offer_auth_required"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">Authentication Required</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.is_redemption"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">Is Redemption</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.report_full_amount"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">Report full amount</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-2 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    v-model="OffersAndPromotion.is_bank_offer"
                    unchecked-value="N"
                    value="Y"
                    @change="onSelectBankOffer($event)"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">{{
                    $t("is_bank_offer")
                  }}</span>
                </div>
              </div>
              <div
                class="col-lg-6 col-xl-3 my-3"
                v-if="OffersAndPromotion.is_bank_offer == 'Y'"
              >
                <div class="d-flex align-items-center">
                  <custommultiselect
                    v-model="OffersAndPromotion.bankDetails['selectedBank']"
                    :options="activeBankList"
                    :placeholder="$tc('Bank')"
                    label="bank_name"
                    isSingleId="bank_id"
                    :multiple="false"
                    track-by="bank_id"
                    @select="onSelectBankv2($event, 'ADD')"
                    @remove="onSelectBankv2($event, 'REMOVE')"
                  >
                  </custommultiselect>
                </div>
                <p
                  v-if="
                    submitted &&
                      OffersAndPromotion.is_bank_offer == 'Y' &&
                      !OffersAndPromotion.bankDetails['bank_id']
                  "
                  class="error_message"
                >
                  <span>{{ $tc("please") }} {{ $tc("selectBank") }}.</span>
                </p>
              </div>
              <div
                class="col-lg-6 col-xl-3 my-3"
                v-if="OffersAndPromotion.is_bank_offer == 'Y'"
              >
                <div class="d-flex align-items-center">
                  <custommultiselect
                    v-model="OffersAndPromotion.bankDetails['selectedCard']"
                    :options="activeBankCardList"
                    :placeholder="$tc('Card Type')"
                    label="card_type"
                    isSingleId="card_id"
                    :multiple="true"
                    track-by="card_id"
                    @select="onSelectCardTypes($event, 'ADD')"
                    @remove="onSelectCardTypes($event, 'REMOVE')"
                  ></custommultiselect>
                </div>
                <p
                  v-if="
                    submitted &&
                      OffersAndPromotion.is_bank_offer == 'Y' &&
                      !OffersAndPromotion.bankDetails['card_type_ids']
                  "
                  class="error_message"
                >
                  <span>{{ $tc("please") }} {{ $tc("selectcardtype") }}.</span>
                </p>
              </div>

              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    v-model="OffersAndPromotion.visible_on_web"
                    @change="onchangeVisible($event, 'full')"
                    name="check-button"
                    class="j-checkbox pb-0"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">{{
                    $t("Visible On Website")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.reportingSettings
        >
          <span class="fs"> {{ "Reporting" }} {{ "Settings" }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="reportingSettings"
          v-model="sectionCollapse.reportingSettings"
        >
          <div class="new-border back rounded-10 px-3 pb-0 mb-2">
            <div class="row align-items-center">
              <div class="col-lg-6 col-xl-3 my-3">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    @change="onChangeReporting($event, 'full')"
                    v-model="OffersAndPromotion.report_full_amount"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">Report full Amt.</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3" v-if="isEpix">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    @change="onChangeReporting($event, 'full_spcl')"
                    v-model="OffersAndPromotion.report_full_amount_special_rc"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold"
                    >Report full Amt. for Spl. RC</span
                  >
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3" v-if="isEpix">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox
                    class="j-checkbox pb-0 ml-3"
                    @change="onChangeReporting($event, 'specific')"
                    v-model="OffersAndPromotion.has_o_reporting_percent"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="font-weight-bold">Report Specific Percent</span>
                </div>
              </div>
              <div
                class="col-lg-6 col-xl-3 my-3"
                v-if="
                  isEpix && OffersAndPromotion.has_o_reporting_percent == 'Y'
                "
              >
                <div class="d-flex align-items-center justify-content-start">
                  <span class="font-weight-bold">Reporting Percent</span>
                  <div class="input-material-sm mx-2">
                    <input
                      style="text-align: right"
                      v-model="OffersAndPromotion.o_reporting_percent"
                      name="dist_share_value"
                      id="dist_share_value"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- BOX 4 -->

      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.offertype
        >
          <span class="fs"> {{ $t("offertypes") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="offertype" v-model="sectionCollapse.offertype">
          <div class="new-border back rounded-10 p-3 mb-2">
            <!--div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("offertypes") }}
        </div-->

            <!--New Design-->
            <div class="row">
              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('fixedDiscount')"
              >
                <b-form-radio
                  value="fixedDiscount"
                  class="j-radio"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("Fixed Discount") }}</div>
                </b-form-radio>
              </div>
              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('buyAndGetFreeTickets')"
              >
                <b-form-radio
                  value="buyAndGetFreeTickets"
                  class="j-radio"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("buyngetfreeticket") }}</div>
                </b-form-radio>
              </div>
              <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('discount')">
                <b-form-radio
                  class="j-radio"
                  value="discount"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("discounts") }}</div>
                </b-form-radio>
              </div>

              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('buyAndGetCombo')"
              >
                <b-form-radio
                  value="buyAndGetCombo"
                  class="j-radio"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("buyandgetcombo") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2 mb-2" v-if="false">
                <b-form-radio
                  class="j-radio"
                  value="customCategoryOffers"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("customercategoryoffer") }}</div>
                </b-form-radio>
              </div>

              <div class="mx-2 mb-2" v-if="false">
                <b-form-radio
                  class="j-radio"
                  value="bankOffer"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("bank") }} {{ $t("offer") }}</div>
                </b-form-radio>
              </div>

              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('fixedPriceTicketFnb')"
              >
                <b-form-radio
                  class="j-radio"
                  value="fixedPriceTicketFnb"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("fixedPriceTicketFnb") }}</div>
                </b-form-radio>
              </div>

              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('buyAndgetOffOnAnother')"
              >
                <b-form-radio
                  class="j-radio"
                  value="buyAndgetOffOnAnother"
                  v-model="selectedOfferType"
                  @change="onChangeOfferType($event)"
                >
                  <div>{{ $t("buyAndgetOffOnAnother") }}</div>
                </b-form-radio>
              </div>

              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('loyalitycustomers')"
              >
                <b-form-radio
                  class="j-radio"
                  value="loyalitycustomers"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("loyalityOffers") }}</div>
                </b-form-radio>
              </div>

              <div
                class="mx-2 mb-2"
                v-if="checkOfferTypeAvailable('fnbItemDiscounts')"
              >
                <b-form-radio
                  class="j-radio"
                  value="fnbItemDiscounts"
                  @change="onChangeOfferType($event)"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("fnbItemDiscounts") }}</div>
                </b-form-radio>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <!-- Fixed Discount-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'fixedDiscount'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-12">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-3 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("Offer Value :") }}
                                <div class="input-material mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required'"
                                    type="number"
                                    @input="
                                      onChangeDiscountValue(
                                        $event,
                                        discountListIndex
                                      )
                                    "
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted && errors.has('discount_buy_value')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="discountList.min_amount_channel_wise"
                                  unchecked-value="N"
                                  value="Y"
                                  @change="
                                    onChangeChannelWise(
                                      $event,
                                      discountListIndex
                                    )
                                  "
                                ></b-form-checkbox>
                                {{ "Channel Wise" }}
                              </div>
                            </div>
                            <div class="col-lg-12 col-xl-2 mb-2 mx-0 px-0">
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <span
                                  v-if="
                                    discountList.min_amount_channel_wise == 'Y'
                                  "
                                  >{{ "Min. Ticket Amt." }}</span
                                >
                                <span v-else>{{ "Min. Bill Amt" }}</span>
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    v-model="discountList.oc_min_ticket_price"
                                    type="number"
                                    name="min_ticket_amount"
                                    id="min_ticket_amount"
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-lg-12 col-xl-2 mb-2 mx-0 px-0"
                              v-if="discountList.min_amount_channel_wise == 'Y'"
                            >
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                {{ "Min Fnb Amt." }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    v-model="discountList.oc_min_fnb_price"
                                    type="number"
                                    name="min_fnb_amount"
                                    id="min_fnb_amount"
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="
                                discountList.oc_discount_value_is_percentage ==
                                  'Y'
                              "
                              class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="number"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                    errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Buy/Get free ticket-->
                <div
                  class="offer-content-wrapper pl-0"
                  style="padding-top: 20px"
                  v-if="selectedOfferType == 'buyAndGetFreeTickets'"
                >
                  <div class="row back_white mx-1 pt-2">
                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("buy") }}
                        <div class="input-material-sm mx-1">
                          <input
                            style="text-align: right"
                            v-model="buyAndGetFreeTickets.oc_buy_no_of_ticket"
                            type="number"
                            name="buy_value"
                            id="buy_value"
                            v-validate="'required|numeric'"
                          />
                        </div>
                        {{ $t("get") }}
                        <div class="input-material-sm mx-2">
                          <input
                            v-model="buyAndGetFreeTickets.oc_get_free_ticket"
                            type="number"
                            name="get_value"
                            id="get_value"
                            v-validate="'required|numeric'"
                          />
                        </div>
                        {{ $t("ofticketsfree") }}
                      </div>
                      <p
                        v-if="
                          (submitted && errors.has('buy_value')) ||
                            (submitted && errors.has('get_value'))
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("buy_value") || errors.first("get_value")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        {{ $tc("minTicketAmount") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="buyAndGetFreeTickets.oc_min_ticket_price"
                            type="number"
                            name="min_ticket_amount"
                            id="min_ticket_amount"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('min_ticket_amount')"
                        class="error_message"
                      >
                        <span>{{ errors.first("min_ticket_amount") }}</span>
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("maxfreeticketpertransaction") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="
                              buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
                            "
                            type="number"
                            name="max_ticket"
                            id="max_ticket"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('max_ticket')"
                        class="error_message"
                      >
                        <span>{{ errors.first("max_ticket") }}</span>
                      </p>
                    </div>

                    <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-4" style="height:38px;">
                    <div class="d-flex align-items-center">
                      {{ $t('cancombinewithotheroffers') }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="buyAndGetFreeTickets.oc_combine_with_other_offers"
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                    <b-collapse v-model="buyAndGetFreeTickets.oc_combine_with_other_offers === 'Y'">
                      <div class="d-flex align-items-center">
                        <b-form-select
                          class="select-curve w-75"
                          :options="currentlyActiveOffers"
                          v-model="buyAndGetFreeTickets.selectedCombineoffer"
                        ></b-form-select>
                      </div>
                    </b-collapse>
                  </div>-->
                  </div>
                </div>

                <!--Discount-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'discount'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-11">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-6 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("buy") }}
                                <div class="input-material-sm mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required|numeric'"
                                    type="text"
                                    v-model="discountList.oc_buy_no_of_ticket"
                                  />
                                </div>
                                {{ $t("ticket_fnbitem") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="discount_get_value"
                                    id="discount_get_value"
                                    v-validate="'required|numeric'"
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  (submitted &&
                                    errors.has('discount_buy_value')) ||
                                    (submitted &&
                                      errors.has('discount_get_value'))
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value") ||
                                    errors.first("discount_get_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                    errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                            <!-- <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-4 mb-xl-0"
                            style="height:38px;"
                          >
                            <div class="d-flex align-items-center h-100">
                              {{ $t('cancombinewithotheroption') }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="discountList.canCombineOtherOffers"
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 align-self-center">
                            <b-collapse v-model="discountList.canCombineOtherOffers === 'Y'">
                              <div class="d-flex align-items-center">
                                <b-form-select
                                  class="select-curve w-75"
                                  :options="currentlyActiveOffers"
                                  v-model="discountList.selectedCombinedOffer"
                                ></b-form-select>
                              </div>
                            </b-collapse>
                          </div>-->
                          </div>
                        </div>
                        <div
                          class="col-lg-2 col-xl-1 d-flex justify-content-center align-items-center"
                          v-if="false"
                        >
                          <button
                            class="btn-transparent mb-3"
                            @click="addDiscount()"
                            v-if="discountListIndex == 0"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="35"
                              width="35"
                            />
                          </button>

                          <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                          <button
                            v-if="discountListIndex !== 0"
                            class="btn-transparent mb-3"
                            @click="removeDiscount(discountListIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Loyality Program Offers-->
                <div
                  class="offer-content-wrapper pt-3 pl-0"
                  v-if="selectedOfferType == 'loyalitycustomers'"
                >
                  <div class="row pl-0 back_white mx-1 pt-2">
                    <div
                      class="col-12 pt-2 pb-0"
                      v-for="(discountList, discountListIndex) in discountLists"
                      :key="discountListIndex"
                    >
                      <div class="row">
                        <div class="col-lg-10 col-xl-11">
                          <div class="row">
                            <div
                              class="col-lg-12 col-xl-6 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("buy") }}
                                <div class="input-material-sm mx-1">
                                  <input
                                    style="text-align: right"
                                    name="discount_buy_value"
                                    id="discount_buy_value"
                                    v-validate="'required|numeric'"
                                    type="text"
                                    v-model="discountList.oc_buy_no_of_ticket"
                                  />
                                </div>
                                {{ $t("ticket_fnbitem") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="discount_get_value"
                                    id="discount_get_value"
                                    v-validate="'required|numeric'"
                                    v-model="discountList.oc_discount_value"
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  (submitted &&
                                    errors.has('discount_buy_value')) ||
                                    (submitted &&
                                      errors.has('discount_get_value'))
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("discount_buy_value") ||
                                    errors.first("discount_get_value")
                                }}</span>
                              </p>
                            </div>
                            <div
                              class="col-lg-6 col-xl-2 align-self-center mb-2"
                            >
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0"
                                  v-model="
                                    discountList.oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                            <div
                              class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                            >
                              <div class="d-flex align-items-center">
                                {{ $t("maxdiscountpertransaction") }}
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="max_discount_per_trans"
                                    id="max_discount_per_trans"
                                    v-validate="'required'"
                                    v-model="
                                      discountList.oc_max_discount_amount
                                    "
                                  />
                                </div>
                              </div>
                              <p
                                v-if="
                                  submitted &&
                                    errors.has('max_discount_per_trans')
                                "
                                class="error_message"
                              >
                                <span>{{
                                  errors.first("max_discount_per_trans")
                                }}</span>
                              </p>
                            </div>
                            <!-- <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-4 mb-xl-0"
                            style="height:38px;"
                          >
                            <div class="d-flex align-items-center h-100">
                              {{ $t('cancombinewithotheroption') }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="discountList.canCombineOtherOffers"
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                          <div class="col-lg-6 col-xl-4 align-self-center">
                            <b-collapse v-model="discountList.canCombineOtherOffers === 'Y'">
                              <div class="d-flex align-items-center">
                                <b-form-select
                                  class="select-curve w-75"
                                  :options="currentlyActiveOffers"
                                  v-model="discountList.selectedCombinedOffer"
                                ></b-form-select>
                              </div>
                            </b-collapse>
                          </div>-->
                          </div>
                        </div>
                        <div
                          class="col-lg-2 col-xl-1 d-flex justify-content-center align-items-center"
                          v-if="false"
                        >
                          <button
                            class="btn-transparent mb-3"
                            @click="addDiscount()"
                            v-if="discountListIndex == 0"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="35"
                              width="35"
                            />
                          </button>

                          <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                          <button
                            v-if="discountListIndex !== 0"
                            class="btn-transparent mb-3"
                            @click="removeDiscount(discountListIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Buy And Get Como-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'buyAndGetCombo'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div
                      class="col-lg-12 col-xl-12 align-self-center mb-4 pl-0"
                    >
                      <div class="d-flex">
                        {{ $t("combinewith") }}:
                        <b-form-radio
                          value="fAndb"
                          class="j-radio ml-4"
                          v-model="buyAndGetCombo.offerApplicableAt"
                        >
                          <div>F&amp;B</div>
                        </b-form-radio>
                        <b-form-radio
                          value="boxOffice"
                          class="j-radio ml-3"
                          v-model="buyAndGetCombo.offerApplicableAt"
                        >
                          <div>{{ $t("boxoffice") }}</div>
                        </b-form-radio>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-if="buyAndGetCombo.offerApplicableAt === 'fAndb'"
                    >
                      <div class="row">
                        <div class="col-lg-12 col-xl-12 pl-0">
                          <div class="row mx-0 align-items-center">
                            <div class="mb-0">
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_buy_item_count
                                "
                                type="text"
                                name="buy_fnb_combo"
                                id="buy_fnb_combo"
                                v-validate="'required|numeric'"
                              />
                            </div>

                            <div class="col-2">
                              <multiselect
                                v-model="buyAndGetCombo.F_And_B.oc_buy_item_id"
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              ></multiselect>
                            </div>
                            <span class="text-nowrap">{{ $t("get") }}</span>

                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_get_item_count
                                "
                                type="text"
                                name="get_fnb_combo"
                                id="get_fnb_combo"
                                v-validate="'required|numeric'"
                              />
                            </div>

                            <div class="col-2">
                              <multiselect
                                v-model="buyAndGetCombo.F_And_B.oc_get_item_id"
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              ></multiselect>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-3"
                                v-model="
                                  buyAndGetCombo.F_And_B.oc_is_combo_free
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              <span class="text-nowrap">Free</span>
                            </div>

                            <div
                              v-if="
                                buyAndGetCombo.F_And_B.oc_is_combo_free === 'N'
                              "
                              style="display: flex"
                            >
                              <div class="d-flex align-items-center ml-3">
                                <span class="text-nowrap"
                                  >&nbsp;{{ $t("offer") }}
                                  {{ $t("value") }}</span
                                >
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="free_combo_offer_value"
                                    id="free_combo_offer_value"
                                    v-validate="'required|decimal'"
                                    v-model="
                                      buyAndGetCombo.F_And_B.oc_discount_value
                                    "
                                  />
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0 ml-3"
                                  v-model="
                                    buyAndGetCombo.F_And_B
                                      .oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                ></b-form-checkbox>
                                {{ $t("Percentage") }}
                              </div>
                            </div>
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('buy_fnb_combo')) ||
                                errors.has('get_fnb_combo') ||
                                (buyAndGetCombo.F_And_B.oc_is_combo_free ===
                                  'N' &&
                                  errors.has('free_combo_offer_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("buy_fnb_combo") ||
                                errors.first("get_fnb_combo") ||
                                errors.first("free_combo_offer_value")
                            }}</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                                buyAndGetCombo.F_And_B.oc_buy_item_count !=
                                  null &&
                                buyAndGetCombo.F_And_B.oc_buy_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for Buy.</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                                buyAndGetCombo.F_And_B.oc_get_item_count !=
                                  null &&
                                buyAndGetCombo.F_And_B.oc_get_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for Get.</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-12"
                      v-if="buyAndGetCombo.offerApplicableAt === 'boxOffice'"
                    >
                      <div class="row">
                        <div class="col-lg-12 col-xl-12 pl-0">
                          <div class="row mx-0 align-items-center">
                            <div>
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_buy_no_of_ticket
                                "
                                type="text"
                                name="buy_bo_combo"
                                id="buy_bo_combo"
                                v-validate="'required|numeric'"
                              />
                            </div>

                            <span class="text-nowrap"
                              >{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span
                            >

                            <div class="col-3">
                              <!-- <input v-model="buyAndGetCombo.boxOffice.getCount" type="number" /> -->

                              <multiselect
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_get_item_id
                                "
                                :options="fnbItems"
                                :placeholder="$tc('fnbitems')"
                                label="item_name"
                                isSingleId="item_id"
                                :multiple="false"
                                track-by="item_id"
                              ></multiselect>
                            </div>
                            <!-- <span class="text-nowrap">{{ $t('tickets') }}&nbsp;&nbsp;</span> -->
                            <div class="d-flex align-items-center" style="">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-1"
                                v-model="
                                  buyAndGetCombo.boxOffice.oc_is_combo_free
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>

                              <span class="text-nowrap">{{ $t("free") }}</span>
                            </div>
                            <div
                              v-if="
                                buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                  'N'
                              "
                              style="display: flex"
                            >
                              <div class="d-flex align-items-center ml-5">
                                <span class="text-nowrap"
                                  >&nbsp;{{ $t("offer") }}
                                  {{ $t("value") }}</span
                                >
                                <div class="input-material-sm mx-2">
                                  <input
                                    style="text-align: right"
                                    type="text"
                                    name="free_combo_bo_offer_value"
                                    id="free_combo_bo_offer_value"
                                    v-validate="'required|decimal'"
                                    v-model="
                                      buyAndGetCombo.boxOffice.oc_discount_value
                                    "
                                  />
                                </div>
                              </div>
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  class="j-checkbox pb-0 ml-3"
                                  v-model="
                                    buyAndGetCombo.boxOffice
                                      .oc_discount_value_is_percentage
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  switch
                                ></b-form-checkbox>
                                {{ $t("isPercentage") }}
                              </div>
                            </div>
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('buy_bo_combo')) ||
                                (buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                  'N' &&
                                  errors.has('free_combo_bo_offer_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("buy_bo_combo") ||
                                errors.first("free_combo_bo_offer_value")
                            }}</span>
                          </p>
                          <p
                            v-else-if="
                              submitted &&
                                buyAndGetCombo.boxOffice.oc_buy_no_of_ticket !=
                                  null &&
                                buyAndGetCombo.boxOffice.oc_get_item_id == null
                            "
                            class="error_message"
                          >
                            <span>Please select F&B item for get.</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Fixed Price Ticket And FNB-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'fixedPriceTicketFnb'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div class="col-lg-12 col-xl-12">
                      <div class="row mx-0 align-items-center">
                        <div>
                          <span class="text-nowrap">{{ $t("buy") }}</span>
                        </div>
                        <div class="input-material-sm mx-1">
                          <input
                            style="text-align: right"
                            v-model="buyTicketFnbFixedPrice.oc_buy_no_of_ticket"
                            type="text"
                            @input="
                              onChangeCount(
                                $event,
                                'buyTicketFnbFixedPrice',
                                'buy'
                              )
                            "
                            name="buy_fixed_price_ticket_count"
                            id="buy_fixed_price_ticket_count"
                            v-validate="'required'"
                          />
                        </div>

                        <span class="text-nowrap">{{ $t("tickets") }}</span>

                        <div style="display: flex">
                          <div class="d-flex align-items-center ml-2">
                            <span class="text-nowrap"
                              >{{ $t("atFlatRate") }}&nbsp;</span
                            >
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="fixedPrice_bo_offer_value"
                                id="fixedPrice_bo_offer_value"
                                v-validate="'required'"
                                v-model="
                                  buyTicketFnbFixedPrice.oc_ticket_at_price
                                "
                              />
                            </div>
                            <span class="text-nowrap">{{ $t("Each") }}</span>
                          </div>
                        </div>

                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            class="j-checkbox pb-0 ml-5"
                            id="combineFixedTicketFnb"
                            name="combineFixedTicketFnb"
                            v-model="buyTicketFnbFixedPrice.oc_combine_with_fnb"
                            unchecked-value="N"
                            value="Y"
                          >
                          </b-form-checkbox>
                          <label class="mt-2" for="combineFixedTicketFnb">
                            {{ $t("combinewithfnb") }}</label
                          >
                        </div>

                        <div style="display: flex">
                          <div class="d-flex align-items-center ml-5">
                            <span class="text-nowrap"
                              >{{ "Max Ticket Limit" }}&nbsp;</span
                            >
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="mx_count_ticket"
                                id="mx_count_ticket"
                                @change="
                                  onChangeCount(
                                    $event,
                                    'buyTicketFnbFixedPrice',
                                    'max'
                                  )
                                "
                                v-model="
                                  buyTicketFnbFixedPrice.oc_max_count_of_ticket
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- SHOW ERROR HERE -->
                    </div>

                    <div
                      class="col-lg-12 col-xl-12 pl-0 mt-3"
                      v-if="buyTicketFnbFixedPrice.oc_combine_with_fnb == 'Y'"
                    >
                      <div
                        class="row mx-0 align-items-center mb-3"
                        v-for="(fnbCombo,
                        fnbComboIndex) in buyTicketFnbFixedPrice.Fnb_criteria"
                        :key="fnbComboIndex"
                      >
                        <div class="col-md-1">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div>
                              <span class="text-nowrap">{{ $t("buy") }}</span>
                            </div>
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                v-model="fnbCombo.oc_buy_no_of_item"
                                type="text"
                                name="buy_fixedprice_item"
                                id="buy_fixedprice_item"
                                v-validate="'required'"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="">
                            <multiselect
                              v-model="fnbCombo.selectedFnbItem"
                              @select="
                                selectFnbItemFixedOffer(
                                  $event,
                                  fnbComboIndex,
                                  'Add'
                                )
                              "
                              @remove="
                                selectFnbItemFixedOffer(
                                  $event,
                                  fnbComboIndex,
                                  'Remove'
                                )
                              "
                              :options="fnbItems"
                              :placeholder="$tc('fnbitems')"
                              label="item_name"
                              isSingleId="item_id"
                              :multiple="false"
                              track-by="item_id"
                            ></multiselect>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <div style="display: flex">
                            <div class="d-flex align-items-center">
                              <span class="text-nowrap"
                                >{{ $t("atFlatRate") }}&nbsp;</span
                              >
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="fixed_fnb_bo_offer_value"
                                  id="fixed_fnb_bo_offer_value"
                                  v-validate="'required'"
                                  v-model="fnbCombo.oc_fnb_at_price"
                                />
                              </div>
                              <span class="text-nowrap">{{ $t("Each") }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <button
                              class="btn-transparent"
                              @click="addFnbCriteria()"
                              v-if="fnbComboIndex == 0"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="29"
                                width="29"
                              />
                            </button>
                            <button
                              v-if="fnbComboIndex !== 0"
                              class="btn-transparent"
                              @click="removeFnbCriteria(fnbComboIndex)"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="29"
                                width="29"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- SHOW ERROR HERE -->
                    </div>
                  </div>
                </div>

                <!--Buy 1 get Off on Another Ticket-->
                <div
                  class="offer-content-wrapper py-0 pl-0"
                  v-if="selectedOfferType == 'buyAndgetOffOnAnother'"
                >
                  <div class="row back_white p-2 mx-1 mt-3">
                    <div class="col-lg-12 col-xl-12">
                      <div
                        class="row d-flex mx-0 align-items-center"
                        style="gap: 35px"
                      >
                        <div class="align-self-center mb-2">
                          <div class="d-flex align-items-center">
                            {{ $t("buy") }}
                            <div class="input-material-sm mx-1">
                              <input
                                style="text-align: right"
                                name="discount_buy_value"
                                id="discount_buy_value"
                                v-validate="'required|numeric'"
                                @input="
                                  onChangeCount(
                                    $event,
                                    'buyAndgetOffOnAnother',
                                    'buy'
                                  )
                                "
                                type="text"
                                v-model="
                                  buyAndgetOffOnAnother.oc_buy_no_of_ticket
                                "
                              />
                            </div>
                            {{ $t("buyAndgetOffOnAnother_des") }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="discount_get_value"
                                id="discount_get_value"
                                v-validate="'required|numeric'"
                                v-model="
                                  buyAndgetOffOnAnother.oc_discount_value
                                "
                              />
                            </div>
                            <span
                              v-if="
                                buyAndgetOffOnAnother.oc_discount_value_is_percentage ==
                                  'Y'
                              "
                              >{{ "%" }}</span
                            >
                            <span v-else>{{ "Flat" }}</span>
                            &nbsp;
                            {{ $t("buyAndgetOffOnAnother_des2") }}
                          </div>
                          <p
                            v-if="
                              (submitted && errors.has('discount_buy_value')) ||
                                (submitted && errors.has('discount_get_value'))
                            "
                            class="error_message"
                          >
                            <span>{{
                              errors.first("discount_buy_value") ||
                                errors.first("discount_get_value")
                            }}</span>
                          </p>
                        </div>
                        <div class="align-self-center mb-2">
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              class="j-checkbox pb-0"
                              v-model="
                                buyAndgetOffOnAnother.oc_discount_value_is_percentage
                              "
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>
                            {{ $t("Percentage") }}
                          </div>
                        </div>
                        <div
                          class="align-self-center mb-lg-2 mb-xl-2"
                          v-if="false"
                        >
                          <div class="d-flex align-items-center">
                            {{ "Upto" }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="max_discount_per_trans"
                                id="max_discount_per_trans"
                                v-model="
                                  buyAndgetOffOnAnother.oc_max_discount_amount
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="align-self-center mb-lg-2 mb-xl-2">
                          <div class="d-flex align-items-center">
                            {{ "Max Ticket Limit" }}
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="max_discount_per_trans"
                                id="max_discount_per_trans"
                                @change="
                                  onChangeCount(
                                    $event,
                                    'buyAndgetOffOnAnother',
                                    'max'
                                  )
                                "
                                v-model="
                                  buyAndgetOffOnAnother.oc_max_count_of_ticket
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="d-flex align-self-center mb-lg-2 mb-xl-2">
                          <div class="mx-2 mb-2">
                            <b-form-radio
                              value="N"
                              class="j-radio"
                              v-model="
                                buyAndgetOffOnAnother.oc_offer_on_higher_amount
                              "
                            >
                              <div>{{ "Lower Price" }}</div>
                            </b-form-radio>
                          </div>
                          <div class="mx-2 mb-2">
                            <b-form-radio
                              value="Y"
                              class="j-radio"
                              v-model="
                                buyAndgetOffOnAnother.oc_offer_on_higher_amount
                              "
                            >
                              <div>{{ "Higher Price" }}</div>
                            </b-form-radio>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Customer Category Offer -->
                <div
                  class="offer-content-wrapper back_white mt-3 p-3"
                  v-if="selectedOfferType == 'customCategoryOffers'"
                >
                  <div class="row">
                    <div class="col-lg-8 align-self-center mb-4">
                      <div class="d-flex">
                        <b-form-radio
                          v-for="(Item, ItmeIndex) in customerOffersCategories"
                          :key="ItmeIndex"
                          @change="onChangeCustomerCategory"
                          v-model="
                            customCategoryOffers.booking_user_category_id
                          "
                          :value="Item.buc_id"
                          class="j-radio col"
                        >
                          <div>{{ $t(Item.buc_category_name) }}&nbsp;</div>
                        </b-form-radio>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      v-if="
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(2) ||
                          String(
                            customCategoryOffers.booking_user_category_id
                          ) === String(4)
                      "
                      class="col-lg-12 col-xl-6 align-self-center mb-3"
                    >
                      <div class="d-flex align-items-center">
                        <multiselect
                          v-model="customCategoryOffers.institution_id"
                          :options="institutionList"
                          :placeholder="$tc('Institute')"
                          label="institution_name"
                          isSingleId="institution_id"
                          :multiple="false"
                          track-by="institution_id"
                        ></multiselect>

                        <p
                          v-if="
                            submitted &&
                              customCategoryOffers.institution_id == null
                          "
                          class="error_message"
                        >
                          <span>{{ $t("pleaseSelectInstitution") }}</span>
                        </p>
                      </div>
                    </div>

                    <div
                      class="align-self-center mb-4"
                      :class="
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(2) ||
                        String(
                          customCategoryOffers.booking_user_category_id
                        ) === String(4)
                          ? 'col-lg-6'
                          : 'col-lg-12'
                      "
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-3 text-nowrap">
                          {{ $t("validateby") }}:
                        </div>
                        <div class="multiselect">
                          <custommultiselect
                            v-model="customCategoryOffers.validate_doc_id"
                            :options="verificationList"
                            :placeholder="$tc('selectVerificationid')"
                            label="vd_document_name"
                            :multiple="true"
                            track-by="vd_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              selectedOfferType == 'customCategoryOffers' &&
                              customCategoryOffers.validate_doc_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $t("please") }}
                            {{ $t("selectVerificationid") }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-5 col-xl-3 mb-4">
                      <div class="d-flex align-items-center">
                        {{ $tc("minimumTicketAmount") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="customCategoryOffers.cco_min_ticket_amount"
                            type="text"
                            name="customer_min_ticket_amount"
                            id="customer_min_ticket_amount"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted && errors.has('customer_min_ticket_amount')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("customer_min_ticket_amount")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        {{ $t("offerprice") }}:
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="customCategoryOffers.cco_offer_value"
                            type="text"
                            name="customer_offer_value"
                            id="customer_offer_value"
                            v-validate="'required|decimal'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('customer_offer_value')"
                        class="error_message"
                      >
                        <span>{{ errors.first("customer_offer_value") }}</span>
                      </p>
                    </div>

                    <div class="col-lg-3 col-xl-2 align-self-center mb-4">
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          class="j-checkbox pb-0 ml-3"
                          v-model="
                            customCategoryOffers.cco_offer_value_is_percentage
                          "
                          unchecked-value="N"
                          value="Y"
                        ></b-form-checkbox>
                        {{ $t("Percentage") }}
                      </div>
                    </div>

                    <div class="col-lg-12 col-xl-4 mb-2">
                      <div class="d-flex align-items-center">
                        {{ $t("MaximumDiscountPerTransaction") }}
                        <div class="input-material-sm mx-2">
                          <input
                            style="text-align: right"
                            v-model="
                              customCategoryOffers.cco_max_discount_amount
                            "
                            type="text"
                            name="customer_max_discount_per_trans"
                            id="customer_max_discount_per_trans"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted &&
                            errors.has('customer_max_discount_per_trans')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("customer_max_discount_per_trans")
                        }}</span>
                      </p>
                    </div>

                    <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("offerprice") }}:
                      <div class="input-material-sm mx-2">
                        <input
                          v-model="customCategoryOffers.cco_offer_value"
                          type="text"
                          name="customer_offer_value"
                          id="customer_offer_value"
                          v-validate="'required|decimal'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('customer_offer_value')"
                      class="error_message"
                    >
                      <span>{{ errors.first("customer_offer_value") }}</span>
                    </p>
                  </div> -->

                    <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("isPercentage") }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="
                          customCategoryOffers.cco_offer_value_is_percentage
                        "
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> -->

                    <div class="w-100">
                      <div class="col-lg-6 col-xl-12 align-self-center mb-1">
                        <div class="d-flex">
                          <div class="input-material-textarea rounded-10">
                            <textarea
                              v-model="customCategoryOffers.cco_instruction"
                              rows="5"
                              class="rounded-10"
                            ></textarea>
                            <label>{{ $t("specialInstruction") }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!---Bank0ffer-->
                <div
                  class="offer-content-wrapper back_white mt-3 p-3"
                  v-if="selectedOfferType == 'bankOffer'"
                >
                  <div class="row">
                    <div class="col-lg-6 col-xl-6 my-2">
                      <div class="d-flex align-items-center">
                        <custommultiselect
                          v-model="bankOffer.bank_id"
                          :options="activeBankList"
                          :placeholder="$tc('Bank')"
                          label="bank_name"
                          isSingleId="bank_id"
                          :multiple="false"
                          track-by="bank_id"
                          @select="onSelectBank($event)"
                        ></custommultiselect>
                      </div>
                      <p
                        v-if="
                          submitted &&
                            selectedOfferType == 'bankOffer' &&
                            bankOffer.bank_id == null
                        "
                        class="error_message"
                      >
                        <span
                          >{{ $tc("please") }} {{ $tc("selectBank") }}.</span
                        >
                      </p>
                    </div>
                    <div class="col-lg-6 col-xl-6 my-2">
                      <div class="d-flex align-items-center">
                        <custommultiselect
                          v-model="bankOffer.card_id"
                          :options="activeBankCardList"
                          :placeholder="$tc('Card Type')"
                          label="card_type"
                          isSingleId="card_id"
                          :multiple="false"
                          track-by="card_id"
                        ></custommultiselect>
                      </div>
                      <p
                        v-if="
                          submitted &&
                            selectedOfferType == 'bankOffer' &&
                            bankOffer.card_id == null
                        "
                        class="error_message"
                      >
                        <span
                          >{{ $tc("please") }}
                          {{ $tc("selectcardtype") }}.</span
                        >
                      </p>
                    </div>

                    <div class="col-lg-12 col-xl-12 mt-2 mb-3">
                      <div class="d-flex">
                        <div>
                          <b-form-radio
                            class="j-radio"
                            value="weekly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("weekly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>

                        <div class="ml-3">
                          <b-form-radio
                            class="j-radio mx-4"
                            value="monthly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("monthly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>

                        <div class="ml-3">
                          <b-form-radio
                            class="j-radio"
                            value="yearly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("yearly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                      <div
                        class="d-flex align-items-center justify-content-start"
                      >
                        <b-form-checkbox
                          class="j-checkbox pb-0"
                          v-model="bankOffer.bo_offer_value_is_percentage"
                          unchecked-value="N"
                          value="Y"
                        ></b-form-checkbox>

                        {{ $t("isPercentage") }}
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                      <div class="d-flex align-items-center">
                        {{ $tc("redemptionCount") }}
                        <div class="input-material-sm ml-2">
                          <input
                            style="text-align: right"
                            v-model="bankOffer.redemptionCount"
                            type="text"
                            name="bank_redemption_count"
                            id="bank_redemption_count"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="submitted && errors.has('bank_redemption_count')"
                        class="error_message"
                      >
                        <span>{{ errors.first("bank_redemption_count") }}</span>
                      </p>
                    </div>

                    <!-- MAX REDEMPTION PER USER -->
                    <div class="col-lg-6 col-xl-4 align-self-center mb-2">
                      <div class="d-flex align-items-center">
                        {{ $tc("maxRedemptionPerUser") }}
                        <div class="input-material-sm ml-2">
                          <input
                            style="text-align: right"
                            v-model="bankOffer.maxRedemptionPerUser"
                            type="text"
                            name="bank_max_redemption_per_user"
                            id="bank_max_redemption_per_user"
                            v-validate="'required|numeric'"
                          />
                        </div>
                      </div>
                      <p
                        v-if="
                          submitted &&
                            errors.has('bank_max_redemption_per_user')
                        "
                        class="error_message"
                      >
                        <span>{{
                          errors.first("bank_max_redemption_per_user")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                      <div class="row">
                        <div class="">
                          <div class="d-flex align-items-center">
                            {{ $t("offerprice") }}
                            <div class="input-material-sm ml-2">
                              <input
                                style="text-align: right"
                                v-model="bankOffer.bo_offer_value"
                                type="text"
                                name="bank_offer_value"
                                id="bank_offer_value"
                                v-validate="'required|decimal'"
                              />
                            </div>
                          </div>
                          <p
                            v-if="submitted && errors.has('bank_offer_value')"
                            class="error_message"
                          >
                            <span>{{ errors.first("bank_offer_value") }}</span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-12 align-self-center mb-1">
                      <div class="d-flex">
                        <div class="input-material-textarea rounded-10">
                          <textarea
                            v-model="bankOffer.bo_instruction"
                            rows="4"
                            class="rounded-10"
                          ></textarea>
                          <label
                            :class="
                              bankOffer.bo_instruction &&
                              bankOffer.bo_instruction.length > 0
                                ? 'shift-up'
                                : ''
                            "
                            >{{ $t("specialinstructonregardingoffer") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Fnb Item Discounts -->
                <div
                  class="offer-content-wrapper back_white mt-3 p-3"
                  v-if="selectedOfferType == 'fnbItemDiscounts'"
                >
                  <div
                    class="row align-items-center my-2"
                    v-for="(fnbItemObj, fnbItemIndexObj) in fnbItemDiscounts"
                    :key="fnbItemIndexObj + 'discountFnbItem'"
                  >
                    <div class="col-9">
                      <div class="row">
                        <div class="col-4">
                          <multiselect
                            v-model="fnbItemObj.fnb_item_code"
                            :options="fnbItems"
                            :placeholder="$tc('fnbitems')"
                            label="item_name"
                            isSingleId="item_id"
                            :multiple="false"
                            track-by="item_id"
                          ></multiselect>
                        </div>
                        <div class="col-4">
                          <div class="input-material">
                            <input
                              v-model="fnbItemObj.fnb_item_offer"
                              placeholder=""
                              type="number"
                            />
                            <label>Offer Percentage</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      <button
                        @click.prevent.stop="removeFnbItemDiscountRow()"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      @click.prevent.stop="addFnbItemDiscountRow()"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--New Design Ends-->

            <div class v-if="false">
              <ul class="select-offers-list">
                <!-- Buy & Get Free Ticket -->
                <li>
                  <b-form-radio
                    value="buyAndGetFreeTickets"
                    class="j-radio"
                    v-model="selectedOfferType"
                    @change="onChangeOfferType($event)"
                  >
                    <div>{{ $t("buyngetfreeticket") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'buyAndGetFreeTickets'"
                  >
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("buy") }}
                          <div class="input-material-sm mx-1">
                            <input
                              class="text-right"
                              v-model="buyAndGetFreeTickets.oc_buy_no_of_ticket"
                              type="text"
                              name="buy_value"
                              id="buy_value"
                              v-validate="'required|numeric'"
                            />
                          </div>
                          {{ $t("get") }}
                          <div class="input-material-sm mx-2">
                            <input
                              class="text-right"
                              v-model="buyAndGetFreeTickets.oc_get_free_ticket"
                              type="text"
                              name="get_value"
                              id="get_value"
                              v-validate="'required|numeric'"
                            />
                          </div>
                          {{ $t("ofticketsfree") }}
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('buy_value')) ||
                              (submitted && errors.has('get_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("buy_value") ||
                              errors.first("get_value")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("minimumTicketAmount") }}
                          <div class="input-material-sm mx-2">
                            <input
                              class="text-right"
                              v-model="buyAndGetFreeTickets.oc_min_ticket_price"
                              type="text"
                              name="min_ticket_amount"
                              id="min_ticket_amount"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('min_ticket_amount')"
                          class="error_message"
                        >
                          <span>{{ errors.first("min_ticket_amount") }}</span>
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("maximumfreeticketpertransaction") }}
                          <div class="input-material-sm mx-2">
                            <input
                              class="text-right"
                              v-model="
                                buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
                              "
                              type="text"
                              name="max_ticket"
                              id="max_ticket"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('max_ticket')"
                          class="error_message"
                        >
                          <span>{{ errors.first("max_ticket") }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- DISCOUNT -->
                <li>
                  <b-form-radio
                    class="j-radio"
                    value="discount"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("discounts") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper pt-0"
                    v-if="selectedOfferType == 'discount'"
                  >
                    <div class="row">
                      <div
                        class="col-12 py-3"
                        v-for="(discountList,
                        discountListIndex) in discountLists"
                        :key="discountListIndex"
                      >
                        <div class="row">
                          <div class="col-lg-10 col-xl-11">
                            <div class="row">
                              <div
                                class="col-lg-12 col-xl-6 align-self-center mb-4"
                              >
                                <div class="d-flex align-items-center">
                                  {{ $t("buy") }}
                                  <div class="input-material-sm mx-1">
                                    <input
                                      name="discount_buy_value"
                                      id="discount_buy_value"
                                      v-validate="'required|numeric'"
                                      type="text"
                                      v-model="discountList.oc_buy_no_of_ticket"
                                    />
                                  </div>
                                  {{ $t("ticket_fnbitem") }}
                                  <div class="input-material-sm mx-2">
                                    <input
                                      type="text"
                                      name="discount_get_value"
                                      id="discount_get_value"
                                      v-validate="'required|numeric'"
                                      v-model="discountList.oc_discount_value"
                                    />
                                  </div>
                                </div>
                                <p
                                  v-if="
                                    (submitted &&
                                      errors.has('discount_buy_value')) ||
                                      (submitted &&
                                        errors.has('discount_get_value'))
                                  "
                                  class="error_message"
                                >
                                  <span>{{
                                    errors.first("discount_buy_value") ||
                                      errors.first("discount_get_value")
                                  }}</span>
                                </p>
                              </div>

                              <div
                                class="col-lg-6 col-xl-6 align-self-center mb-4"
                              >
                                <div class="d-flex align-items-center">
                                  {{ $t("isPercentage") }}
                                  <b-form-checkbox
                                    class="ml-3"
                                    v-model="
                                      discountList.oc_discount_value_is_percentage
                                    "
                                    unchecked-value="N"
                                    value="Y"
                                    switch
                                  ></b-form-checkbox>
                                </div>
                              </div>
                              <div
                                class="col-lg-12 col-xl-6 align-self-center mb-lg-4 mb-xl-0"
                              >
                                <div class="d-flex align-items-center">
                                  {{ $t("maxdiscountpertransaction") }}
                                  <div class="input-material-sm mx-2">
                                    <input
                                      type="text"
                                      name="max_discount_per_trans"
                                      id="max_discount_per_trans"
                                      v-validate="'required'"
                                      v-model="
                                        discountList.oc_max_discount_amount
                                      "
                                    />
                                  </div>
                                </div>
                                <p
                                  v-if="
                                    submitted &&
                                      errors.has('max_discount_per_trans')
                                  "
                                  class="error_message"
                                >
                                  <span>{{
                                    errors.first("max_discount_per_trans")
                                  }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-2 col-xl-1 d-flex justify-content-center align-items-center"
                            v-if="false"
                          >
                            <button
                              class="btn-transparent mb-3"
                              @click="addDiscount()"
                              v-if="discountListIndex == 0"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="35"
                                width="35"
                              />
                            </button>

                            <!-- <button
                          v-if="discountListIndex === 0 && discountLists.length !== 1"
                          class="btn-transparent mb-3"
                          @click="removeDiscount(discountListIndex)"
                        >
                          <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                        </button>-->

                            <button
                              v-if="discountListIndex !== 0"
                              class="btn-transparent mb-3"
                              @click="removeDiscount(discountListIndex)"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="35"
                                width="35"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Buy And Get Como -->
                <li>
                  <b-form-radio
                    value="buyAndGetCombo"
                    class="j-radio"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("buyandgetcombo") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'buyAndGetCombo'"
                  >
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 align-self-center mb-4">
                        <div class="d-flex">
                          {{ $t("combinewith") }}:
                          <b-form-radio
                            value="fAndb"
                            class="j-radio ml-4"
                            v-model="buyAndGetCombo.offerApplicableAt"
                          >
                            <div>F&amp;B</div>
                          </b-form-radio>
                          <b-form-radio
                            value="boxOffice"
                            class="j-radio ml-3"
                            v-model="buyAndGetCombo.offerApplicableAt"
                          >
                            <div>{{ $t("boxoffice") }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                      <div
                        class="col-lg-12 col-xl-12"
                        v-if="buyAndGetCombo.offerApplicableAt === 'fAndb'"
                      >
                        <div class="row mx-0 align-items-center">
                          <div class="mb-2">
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input
                              v-model="buyAndGetCombo.F_And_B.oc_buy_item_count"
                              type="text"
                              name="buy_fnb_combo"
                              id="buy_fnb_combo"
                              v-validate="'required|numeric'"
                            />
                          </div>

                          <div class="multiselect-sm select-curve mx-2">
                            <custommultiselect
                              v-model="buyAndGetCombo.F_And_B.oc_buy_item_id"
                              :options="fnbItems"
                              placeholder="Select F&B Item"
                              label="item_name"
                              isSingleId="item_id"
                              :multiple="false"
                              track-by="item_id"
                            ></custommultiselect>
                          </div>
                          <span class="text-nowrap">{{ $t("get") }}</span>

                          <div class="input-material-sm mx-2">
                            <input
                              v-model="buyAndGetCombo.F_And_B.oc_get_item_count"
                              type="text"
                              name="get_fnb_combo"
                              id="get_fnb_combo"
                              v-validate="'required|numeric'"
                            />
                          </div>

                          <div class="multiselect-sm select-curve mx-2">
                            <custommultiselect
                              v-model="buyAndGetCombo.F_And_B.oc_get_item_id"
                              :options="fnbItems"
                              placeholder="Select F&B Item"
                              label="item_name"
                              isSingleId="item_id"
                              :multiple="false"
                              track-by="item_id"
                            ></custommultiselect>
                          </div>
                          <div class="d-flex align-items-center">
                            <span class="text-nowrap">Free</span>
                            <b-form-checkbox
                              class="ml-3"
                              v-model="buyAndGetCombo.F_And_B.oc_is_combo_free"
                              unchecked-value="N"
                              value="Y"
                              switch
                            ></b-form-checkbox>
                          </div>

                          <div
                            v-if="
                              buyAndGetCombo.F_And_B.oc_is_combo_free === 'N'
                            "
                            style="display: flex"
                          >
                            <div class="d-flex align-items-center ml-3">
                              <span class="text-nowrap"
                                >&nbsp;{{ $t("offer") }} {{ $t("value") }}</span
                              >
                              <div class="input-material-sm mx-2">
                                <input
                                  type="text"
                                  name="free_combo_offer_value"
                                  id="free_combo_offer_value"
                                  v-validate="'required|decimal'"
                                  v-model="
                                    buyAndGetCombo.F_And_B.oc_discount_value
                                  "
                                />
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              {{ $t("isPercentage") }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="
                                  buyAndGetCombo.F_And_B
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('buy_fnb_combo')) ||
                              errors.has('get_fnb_combo') ||
                              (buyAndGetCombo.F_And_B.oc_is_combo_free ===
                                'N' &&
                                errors.has('free_combo_offer_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("buy_fnb_combo") ||
                              errors.first("get_fnb_combo") ||
                              errors.first("free_combo_offer_value")
                          }}</span>
                        </p>
                        <p
                          v-else-if="
                            submitted &&
                              buyAndGetCombo.F_And_B.oc_buy_item_count !=
                                null &&
                              buyAndGetCombo.F_And_B.oc_buy_item_id == null
                          "
                          class="error_message"
                        >
                          <span>Please select F&B item for Buy.</span>
                        </p>
                        <p
                          v-else-if="
                            submitted &&
                              buyAndGetCombo.F_And_B.oc_get_item_count !=
                                null &&
                              buyAndGetCombo.F_And_B.oc_get_item_id == null
                          "
                          class="error_message"
                        >
                          <span>Please select F&B item for Get.</span>
                        </p>
                      </div>

                      <div
                        class="col-12"
                        v-if="buyAndGetCombo.offerApplicableAt === 'boxOffice'"
                      >
                        <div class="row">
                          <div class="col-lg-12 col-xl-12">
                            <div class="row mx-0 align-items-center">
                              <div>
                                <span class="text-nowrap">{{ $t("buy") }}</span>
                              </div>
                              <div class="input-material-sm mx-1">
                                <input
                                  v-model="
                                    buyAndGetCombo.boxOffice.oc_buy_no_of_ticket
                                  "
                                  type="text"
                                  name="buy_bo_combo"
                                  id="buy_bo_combo"
                                  v-validate="'required|numeric'"
                                />
                              </div>

                              <span class="text-nowrap"
                                >{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span
                              >

                              <div class="input-material-sm mx-2">
                                <!-- <input v-model="buyAndGetCombo.boxOffice.getCount" type="number" /> -->
                                <div
                                  class="multiselect-sm select-curve mx-2"
                                  style="min-width: 180px"
                                >
                                  <custommultiselect
                                    v-model="
                                      buyAndGetCombo.boxOffice.oc_get_item_id
                                    "
                                    :options="fnbItems"
                                    :placeholder="$tc('SelectFBItem')"
                                    label="item_name"
                                    isSingleId="item_id"
                                    :multiple="false"
                                    track-by="item_id"
                                  ></custommultiselect>
                                </div>
                              </div>
                              <!-- <span class="text-nowrap">{{ $t('tickets') }}&nbsp;&nbsp;</span> -->
                              <div
                                class="d-flex align-items-center"
                                style="margin-left: 8rem"
                              >
                                <span class="text-nowrap">{{
                                  $t("free")
                                }}</span>
                                <b-form-checkbox
                                  class="ml-1"
                                  v-model="
                                    buyAndGetCombo.boxOffice.oc_is_combo_free
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  switch
                                ></b-form-checkbox>
                              </div>
                              <div
                                v-if="
                                  buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                    'N'
                                "
                                style="display: flex"
                              >
                                <div class="d-flex align-items-center ml-5">
                                  <span class="text-nowrap"
                                    >&nbsp;{{ $t("offer") }}
                                    {{ $t("value") }}</span
                                  >
                                  <div class="input-material-sm mx-2">
                                    <input
                                      type="text"
                                      name="free_combo_bo_offer_value"
                                      id="free_combo_bo_offer_value"
                                      v-validate="'required|decimal'"
                                      v-model="
                                        buyAndGetCombo.boxOffice
                                          .oc_discount_value
                                      "
                                    />
                                  </div>
                                </div>
                                <div class="d-flex align-items-center">
                                  {{ $t("isPercentage") }}
                                  <b-form-checkbox
                                    class="ml-3"
                                    v-model="
                                      buyAndGetCombo.boxOffice
                                        .oc_discount_value_is_percentage
                                    "
                                    unchecked-value="N"
                                    value="Y"
                                    switch
                                  ></b-form-checkbox>
                                </div>
                              </div>
                            </div>
                            <p
                              v-if="
                                (submitted && errors.has('buy_bo_combo')) ||
                                  (buyAndGetCombo.boxOffice.oc_is_combo_free ===
                                    'N' &&
                                    errors.has('free_combo_bo_offer_value'))
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("buy_bo_combo") ||
                                  errors.first("free_combo_bo_offer_value")
                              }}</span>
                            </p>
                            <p
                              v-else-if="
                                submitted &&
                                  buyAndGetCombo.boxOffice
                                    .oc_buy_no_of_ticket != null &&
                                  buyAndGetCombo.boxOffice.oc_get_item_id ==
                                    null
                              "
                              class="error_message"
                            >
                              <span>Please select F&B item for get.</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Customer Category Offer -->
                <li>
                  <b-form-radio
                    class="j-radio"
                    value="customCategoryOffers"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("customercategoryoffer") }}</div>
                  </b-form-radio>

                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'customCategoryOffers'"
                  >
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="d-flex mb-3">
                          <b-form-radio
                            v-for="(Item,
                            ItmeIndex) in customerOffersCategories"
                            :key="ItmeIndex"
                            @change="onChangeCustomerCategory"
                            v-model="
                              customCategoryOffers.booking_user_category_id
                            "
                            :value="Item.buc_id"
                            class="j-radio col"
                          >
                            <div>{{ $t(Item.buc_category_name) }}&nbsp;</div>
                          </b-form-radio>
                        </div>
                      </div>
                      <div
                        v-if="
                          String(
                            customCategoryOffers.booking_user_category_id
                          ) === String(2) ||
                            String(
                              customCategoryOffers.booking_user_category_id
                            ) === String(4)
                        "
                        class="col-lg-8 align-self-center mb-4"
                      >
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="customCategoryOffers.institution_id"
                            :options="institutionList"
                            :placeholder="$tc('selectInstitute')"
                            label="institution_name"
                            isSingleId="institution_id"
                            :multiple="false"
                            track-by="institution_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              customCategoryOffers.institution_id == null
                          "
                          class="error_message"
                        >
                          <span>{{ $t("pleaseSelectInstitution") }}</span>
                        </p>
                      </div>

                      <div class="col-lg-8 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          <div class="mr-3 text-nowrap">
                            {{ $t("validateby") }}:
                          </div>
                          <custommultiselect
                            v-model="customCategoryOffers.validate_doc_id"
                            :options="verificationList"
                            :placeholder="$tc('selectVerificationid')"
                            label="vd_document_name"
                            :multiple="true"
                            track-by="vd_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              selectedOfferType == 'customCategoryOffers' &&
                              customCategoryOffers.validate_doc_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $t("please") }}
                            {{ $t("selectVerificationid") }}</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-5 col-xl-5 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("minimumTicketAmount") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="
                                customCategoryOffers.cco_min_ticket_amount
                              "
                              type="text"
                              name="customer_min_ticket_amount"
                              id="customer_min_ticket_amount"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              errors.has('customer_min_ticket_amount')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_min_ticket_amount")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-4 col-xl-4 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("offerprice") }}:
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="customCategoryOffers.cco_offer_value"
                              type="text"
                              name="customer_offer_value"
                              id="customer_offer_value"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('customer_offer_value')"
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_offer_value")
                          }}</span>
                        </p>
                      </div>

                      <div class="col-lg-3 col-xl-3 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("isPercentage") }}
                          <b-form-checkbox
                            class="ml-3"
                            v-model="
                              customCategoryOffers.cco_offer_value_is_percentage
                            "
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("MaximumDiscountPerTransaction") }}
                          <div class="input-material-sm mx-2">
                            <input
                              v-model="
                                customCategoryOffers.cco_max_discount_amount
                              "
                              type="text"
                              name="customer_max_discount_per_trans"
                              id="customer_max_discount_per_trans"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              errors.has('customer_max_discount_per_trans')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("customer_max_discount_per_trans")
                          }}</span>
                        </p>
                      </div>

                      <!-- <div class="col-lg-6 col-xl-6 mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("offerprice") }}:
                      <div class="input-material-sm mx-2">
                        <input
                          v-model="customCategoryOffers.cco_offer_value"
                          type="text"
                          name="customer_offer_value"
                          id="customer_offer_value"
                          v-validate="'required|decimal'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('customer_offer_value')"
                      class="error_message"
                    >
                      <span>{{ errors.first("customer_offer_value") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-6 mb-4">
                    <div class="d-flex align-items-center">
                      {{ $t("isPercentage") }}
                      <b-form-checkbox
                        class="ml-3"
                        v-model="
                          customCategoryOffers.cco_offer_value_is_percentage
                        "
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </div> -->

                      <div class="col-lg-12 col-xl-8 align-self-center mb-4">
                        <div class="d-flex">
                          <div class="input-material-textarea rounded-10">
                            <textarea
                              v-model="customCategoryOffers.cco_instruction"
                              rows="5"
                              class="rounded-10"
                            ></textarea>
                            <label>{{ $t("specialInstruction") }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Bank Offer -->
                <li class="pb-3">
                  <b-form-radio
                    class="j-radio"
                    value="bankOffer"
                    v-model="selectedOfferType"
                  >
                    <div>{{ $t("bank") }} {{ $t("offer") }}</div>
                  </b-form-radio>
                  <div
                    class="offer-content-wrapper"
                    v-if="selectedOfferType == 'bankOffer'"
                  >
                    <div class="row">
                      <!-- SELECT BANK -->
                      <div class="col-lg-6 col-xl-6 mb-4">
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="bankOffer.bank_id"
                            :options="activeBankList"
                            :placeholder="$tc('selectBank')"
                            label="bank_name"
                            isSingleId="bank_id"
                            :multiple="false"
                            track-by="bank_id"
                            @select="onSelectBank($event)"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              selectedOfferType == 'bankOffer' &&
                              bankOffer.bank_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $tc("please") }} {{ $tc("selectBank") }}.</span
                          >
                        </p>
                      </div>

                      <!-- BANK CARD TYPE -->
                      <div class="col-lg-6 col-xl-6 mb-4">
                        <div class="d-flex align-items-center">
                          <custommultiselect
                            v-model="bankOffer.card_id"
                            :options="activeBankCardList"
                            :placeholder="$tc('selectCardType')"
                            label="card_type"
                            isSingleId="card_id"
                            :multiple="false"
                            track-by="card_id"
                          ></custommultiselect>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              selectedOfferType == 'bankOffer' &&
                              bankOffer.card_id == null
                          "
                          class="error_message"
                        >
                          <span
                            >{{ $tc("please") }}
                            {{ $tc("selectcardtype") }}.</span
                          >
                        </p>
                      </div>

                      <div class="col-lg-12 col-xl-12 mb-4">
                        <div class="d-flex">
                          <b-form-radio
                            class="j-radio"
                            value="weekly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("weekly") }} {{ $t("offer") }}</div>
                          </b-form-radio>

                          <b-form-radio
                            class="j-radio mx-4"
                            value="monthly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("monthly") }} {{ $t("offer") }}</div>
                          </b-form-radio>

                          <b-form-radio
                            class="j-radio"
                            value="yearly"
                            v-model="bankOffer.offerForDuration"
                          >
                            <div>{{ $t("yearly") }} {{ $t("offer") }}</div>
                          </b-form-radio>
                        </div>
                      </div>

                      <!-- IS PERCENTAGE -->
                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $t("isPercentage") }}
                          <b-form-checkbox
                            class="ml-3"
                            v-model="bankOffer.bo_offer_value_is_percentage"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>

                      <!-- REDEMPTION COUNT -->
                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("redemptionCount") }}
                          <div class="input-material-sm ml-2">
                            <input
                              v-model="bankOffer.redemptionCount"
                              type="text"
                              name="bank_redemption_count"
                              id="bank_redemption_count"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted && errors.has('bank_redemption_count')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("bank_redemption_count")
                          }}</span>
                        </p>
                      </div>

                      <!-- MAX REDEMPTION PER USER -->
                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-items-center">
                          {{ $tc("maxRedemptionPerUser") }}
                          <div class="input-material-sm ml-2">
                            <input
                              v-model="bankOffer.maxRedemptionPerUser"
                              type="text"
                              name="bank_max_redemption_per_user"
                              id="bank_max_redemption_per_user"
                              v-validate="'required|numeric'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            submitted &&
                              errors.has('bank_max_redemption_per_user')
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("bank_max_redemption_per_user")
                          }}</span>
                        </p>
                      </div>

                      <!-- OFFER PRICE -->
                      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                        <div class="d-flex align-item-center">
                          {{ $t("offerprice") }}
                          <div class="input-material-sm ml-2">
                            <input
                              v-model="bankOffer.bo_offer_value"
                              type="text"
                              name="bank_offer_value"
                              id="bank_offer_value"
                              v-validate="'required|decimal'"
                            />
                          </div>
                        </div>
                        <p
                          v-if="submitted && errors.has('bank_offer_value')"
                          class="error_message"
                        >
                          <span>{{ errors.first("bank_offer_value") }}</span>
                        </p>
                      </div>

                      <!-- TEXTAREA -->
                      <div class="col-lg-12 col-xl-8 align-self-center mb-4">
                        <div class="d-flex">
                          <div class="input-material-textarea rounded-10">
                            <textarea
                              v-model="bankOffer.bo_instruction"
                              rows="4"
                              class="rounded-10"
                            ></textarea>
                            <label
                              :class="
                                bankOffer.bo_instruction &&
                                bankOffer.bo_instruction.length > 0
                                  ? 'shift-up'
                                  : ''
                              "
                            >
                              {{ $t("specialinstructonregardingoffer") }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <!-- Promo Code -->
                <!-- <li class="pb-3">
              <div class="offer-title">
                <b-form-radio
                  class="j-radio"
                  value="promoCode"
                  v-model="selectedOfferType"
                >
                  <div>{{ $t("promocode") }}</div>
                </b-form-radio>
              </div>

              <div
                class="offer-content-wrapper"
                v-if="selectedOfferType == 'promoCode'"
              >
                <div class="row">

                  <div class="col-lg-12 col-xl-6 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      <div class="text-nowrap mr-3">
                        {{ $t("send") }} {{ $t("promocode") }} via
                      </div>
                      <div>{{ $t("email") }}</div>
                      <b-form-checkbox
                        class="ml-3"
                        v-model="promoCode.pcs_send_email"
                        unchecked-value="N"
                        value="Y"
                        switch
                      ></b-form-checkbox>

                      <div class="d-flex align-items-center w-100 ml-4">
                        <div>SMS</div>
                        <b-form-checkbox
                          class="ml-2"
                          v-model="promoCode.pcs_send_sms"
                          unchecked-value="N"
                          value="Y"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>


                  <div class="col-lg-12 col-xl-4 align-self-center mb-4">
                    <div class="d-flex align-items-center">
                      Multiple Promocode
                      <b-form-checkbox
                        switch
                        v-model="promoCode.multiplePromocode"
                        unchecked-value="N"
                        @input="onChangeMultipleHandler"
                        value="Y"
                        class="ml-3"
                      ></b-form-checkbox>
                    </div>
                  </div>


                  <div class="col-lg-6 col-xl-6 align-self-center mb-4">
                    <custommultiselect
                      v-model="promoCode.booking_user_category_id"
                      :options="customerOffersCategories"
                      placeholder="Select Patron Category"
                      label="buc_category_name"
                      isSingleId="buc_id"
                      :multiple="true"
                      track-by="buc_id"
                    ></custommultiselect>
                    <p
                      v-if="
                        submitted && promoCode.booking_user_category_id == null
                      "
                      class="error_message"
                    >
                      <span>Please select patron category.</span>
                    </p>
                  </div>


                  <div
                    v-if="booking_user_category"
                    class="col-lg-6 col-xl-6 align-self-center mb-4"
                  >
                    <custommultiselect
                      v-model="promoCode.institution_id"
                      :options="institutionList"
                      placeholder="Select Institute"
                      label="institution_name"
                      isSingleId="institution_id"
                      :multiple="false"
                      track-by="institution_id"
                    ></custommultiselect>
                    <p
                      v-if="submitted && promoCode.institution_id == null"
                      class="error_message"
                    >
                      <span>Please select institute.</span>
                    </p>
                  </div>


                  <div
                    class="col-lg-12 col-xl-12 align-self-center border-bottom py-3"
                    v-for="(promoItem, promoIndex) in promoCode.promoCodeList"
                    :key="promoIndex"
                  >
                    <div class="row">
                      <div class="col-lg-11 col-xl-11">
                        <div class="row">
                          <div class="col-12 mb-3">
                            <div class="d-flex align-items-center">
                              {{ $t("promocode") }}
                              <div
                                class="input-material-sm mx-2"
                                style="width: 200px"
                              >
                                <input
                                  type="text"
                                  class="text-uppercase border-dashed border-dark"
                                  v-model="promoItem.promo_code"
                                  name="promo_code"
                                  id="promo_code"
                                  v-validate="'required|alpha_num'"
                                />
                              </div>
                              {{ $t("applicablefor") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  type="text"
                                  class="text-uppercase"
                                  name="applicalbe_for"
                                  id="applicalbe_for"
                                  v-validate="'required|numeric'"
                                  v-model="promoItem.noOfTransaction"
                                />
                              </div>
                              {{ $t("transactions") }}
                            </div>
                            <p
                              v-if="
                                (submitted && errors.has('promo_code')) ||
                                  errors.has('applicalbe_for')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("promo_code") ||
                                  errors.first("applicalbe_for")
                              }}</span>
                            </p>
                          </div>


                          <div class="col-lg-6 mb-4">
                            <div class="d-flex align-items-center">
                              {{ "Minimum ticket amount" }}
                              <div class="input-material-sm mx-2">
                                <input
                                  v-model="promoItem.pcs_min_ticket_amount"
                                  type="text"
                                  name="promo_min_ticket_amount"
                                  id="promo_min_ticket_amount"
                                  v-validate="'required|decimal'"
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted &&
                                  errors.has('promo_min_ticket_amount')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("promo_min_ticket_amount")
                              }}</span>
                            </p>
                          </div>


                          <div class="col-lg-12 col-xl-6 mb-4">
                            <div class="d-flex align-items-center">
                              {{ $t("MaximumDiscountPerTransaction") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  v-model="promoItem.pcs_max_discount_amount"
                                  type="text"
                                  name="promo_max_discount_per_user"
                                  id="promo_max_discount_per_user"
                                  v-validate="'required|numeric'"
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted &&
                                  errors.has('promo_max_discount_per_user')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("promo_max_discount_per_user")
                              }}</span>
                            </p>
                          </div>


                          <div class="col-lg-6">
                            <div class="d-flex align-items-center">
                              {{ $t("offerprice") }}:
                              <div class="input-material-sm mx-2">
                                <input
                                  v-model="promoItem.pcs_offer_value"
                                  type="text"
                                  name="promo_offer_value"
                                  id="promo_offer_value"
                                  v-validate="'required|decimal'"
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted && errors.has('promo_offer_value')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("promo_offer_value")
                              }}</span>
                            </p>
                          </div>


                          <div class="col-lg-6">
                            <div class="d-flex align-items-center">
                              {{ $t("isPercentage") }}
                              <b-form-checkbox
                                class="ml-3"
                                v-model="
                                  promoItem.pcs_offer_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-1 col-xl-1 align-self-center"
                        v-if="promoCode.multiplePromocode == 'Y'"
                      >
                        <div
                          class="d-flex justify-content-center align-item-center"
                        >
                          <button
                            v-if="promoIndex == 0"
                            class="btn-transparent"
                            @click="addMorePromo()"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="25"
                              width="25"
                            />
                          </button>
                          <button
                            v-else
                            class="btn-transparent"
                            @click="removePromo(promoIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="25"
                              width="25"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-lg-12 mt-3">
                    <div class="input-material-textarea rounded-10">
                      <textarea
                        v-model="promoCode.pcs_instruction"
                        rows="4"
                        class="rounded-10"
                      ></textarea>
                      <label>{{ $t("specialInstruction") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </li> -->
              </ul>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- BOX 2 -->

      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.outlet
        >
          <span class="fs"> {{ $t("redemptionOutlet") }}</span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="outlet" v-model="sectionCollapse.outlet">
          <div class="new-border rounded-10 p-3 back mb-2">
            <!--div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("redemptionOutlet") }}
        </div-->
            <div class="row">
              <div class="col-lg-4 col-xl-3 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="OffersAndPromotion.is_employee_offer == 'Y'"
                    v-model="RedemptionOutlet.offer_redeem_at_online"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>

                  <div class="mr-3">{{ $t("canavailonline") }}</div>
                </div>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="['fnbItemDiscounts'].includes(selectedOfferType)"
                    v-model="RedemptionOutlet.offer_redeem_at_boxoffice"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <div class="mr-3">{{ $t("availatboxoffice") }}</div>
                </div>
              </div>

              <div class="col-lg-4 col-xl-4 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    :disabled="
                      [
                        'buyAndGetFreeTickets',
                        'fixedPriceTicketFnb',
                        'buyAndgetOffOnAnother',
                        'fnbItemDiscounts',
                      ].includes(selectedOfferType)
                    "
                    v-model="RedemptionOutlet.offer_redeem_at_concession"
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <div class="mr-3 d-flex">
                    {{ $t("availatconcession") }} <br />
                    <span class="text-muted fs-12">{{
                      [
                        "buyAndGetFreeTickets",
                        "fixedPriceTicketFnb",
                        "buyAndgetOffOnAnother",
                      ].includes(selectedOfferType)
                        ? "(Not Applicable)"
                        : ""
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 mb-2 mt-3" v-if="showGrossNetButton">
                <div class="d-flex align-items-center">
                  <b-form-radio
                    value="gross_amount"
                    class="j-radio"
                    v-model="RedemptionOutlet.offer_applicable_on"
                  >
                    <div>
                      <span>{{ $tc("offerApplicableOnGrossAmount") }}</span>
                    </div>
                  </b-form-radio>
                  <strong class="mx-3">OR</strong>

                  <b-form-radio
                    value="net_amount"
                    class="j-radio"
                    v-model="RedemptionOutlet.offer_applicable_on"
                  >
                    <div>
                      <span>{{ $tc("offerApplicableOnNetAmount") }}</span>
                    </div>
                  </b-form-radio>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <!-- Distributor Share Value -->
      <section class="mb-2">
        <div
          class="section-title mb-3 d-flex justify-content-between section-border section-border"
          style="padding: 6px; align-items: center"
          v-b-toggle.dist_share
        >
          <span class="fs">Distributor Reporting Values</span>

          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>

        <b-collapse
          id="dist_share"
          class="mt-2"
          v-model="sectionCollapse.dist_share"
        >
          <div class="new-border rounded-10 back">
            <template v-if="distShareValues.length">
              <div
                class="row my-2 p-2 justify-content-between"
                v-for="(distValues, distValueIndex) in distShareValues"
                :key="distValueIndex"
              >
                <div class="col-10">
                  <div class="row justify-content-between">
                    <div class="col-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="distValues.seat_type_id ? 'shift-up' : ''"
                          >Seat Type</label
                        >
                      </div>
                      <div>
                        <!-- v-model="OfferConfiguraion.cine_id" -->
                        <!-- @input="getScreenList" -->

                        <!-- <multiselect v-model="distValues.seat_type_id" :options="seatTypesList" label="sst_seat_type"
                        :multiple="false" track-by="sst_id">
                      </multiselect> -->
                        <multiselect
                          v-model="distValues.seat_type_id"
                          :options="seatTypesList"
                          :multiple="true"
                          group-values="screensData"
                          group-label="screen_name"
                          :group-select="true"
                          :searchable="true"
                          :showLabels="false"
                          label="sst_seat_type"
                          placeholder=""
                          track-by="sst_id"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="distValues.ticket_type_id ? 'shift-up' : ''"
                          >Ticket Type</label
                        >
                      </div>
                      <div>
                        <!-- v-model="OfferConfiguraion.cine_id" -->
                        <!-- @input="getScreenList" -->

                        <multiselect
                          v-model="distValues.ticket_type_id"
                          :options="TicketTypes"
                          label="tt_name"
                          placeholder=""
                          :multiple="true"
                          track-by="tt_id"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="distValues.dist_value"
                          name="dist_value"
                          id="dist_value"
                        />
                        <label>Dist. Value</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <button
                    class="btn-transparent mb-3"
                    @click="removeDistValue(distValueIndex)"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </template>
            <div class="row justify-content-center">
              <button
                class="btn-transparent mb-3"
                @click="addMoreDistShareValues()"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </b-collapse>
      </section>

      <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="false">
        <div class="d-flex align-items-center">
          <label class="mb-0 mr-3">{{ $t("active") }}</label>
          <b-form-checkbox
            v-model="OffersAndPromotion.os_is_active"
            name="check-button"
            switch
          ></b-form-checkbox>
        </div>
      </div>

      <!-- SAVE OFFER BUTTON -->
      <div class="col-12 mt-4 text-center">
        <button
          class="btn-blue"
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(true)"
        >
          {{ $t("save") }}
        </button>
        <button
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(false)"
          class="btn-blue"
        >
          {{ $t("saveaddmore") }}
        </button>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="'Offer Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      :img_desc="'Offer Image'"
      :resetImgData="false"
      :category="'Offer Image'"
    ></ImageGallery>
  </div>
</template>

<script>
  import { generateRandomCode } from "@/helper/collection";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import moment from "moment";
  import PosFnBService from "@/services/Pos_Fnb_Service";
  import MarketingService from "@/services/MarketingService";
  import ClientService from "@/services/ClientService";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import { VueEditor } from "vue2-editor";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import { BASEURL } from "@/config/index";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  let Start_Date = moment(
    `${moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD")} 24:00:00`
  ).format();
  let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

  export default {
    components: { DatePicker, VueTimepicker, VueEditor, ImageGallery },
    data() {
      return {
        banner_image_height: "690",
        banner_image_width: "2400",
        poster_image_height: "400",
        poster_image_width: "400",
        set_height: null,
        set_width: null,
        showModal: null,
        value: "",
        submitted: false,
        editCode: false,
        isEdit: true,
        isEditHtml: false,
        notempty: [false, false, false, false, false, false],
        btenable: false,
        TicketTypes: [],
        promoDistShareValues: [],
        distShareValues: [],
        seatTypesList: [],
        movieFormats: [],
        selectedMovieFormats: [],
        offerMovies: {
          is_applicable: "movies_applicable",
        },
        //SAIF
        clientList: [],
        cinemasList: [],
        screenList: [],
        seatClassList: [],
        movieList: [],
        fnbItems: [],
        customerOffersCategories: [],
        institutionList: [],
        activeBankList: [],
        activeBankCardList: [],
        verificationList: [],
        selectedOfferGroupType: {},
        offerGroupType: [],

        OffersAndPromotion: {
          offer_title: "",
          pg_promo_code: [],
          offer_code: "PO-" + generateRandomCode(8),
          offer_description_text: "",
          offer_banner_image: "",
          offer_poster_image: "",
          offer_start_date_time: Start_Date,
          offer_end_date_time: End_date,
          offerValidFor: "fAndb",
          client_id: null,
          share_value: null,
          share_is_percentage: "Y",
          is_employee_offer: "N",
          is_bank_offer: "N",
          bankDetails: {
            selectedBank: "",
            selectedCard: "",
            bank_id: null,
            card_type_ids: null,
          },
          selectedClient: [],
          os_is_active: true,
          startTime2: "",
          endTime2: "",
          is_offer_auth_required: "N",
          is_foreign_movie_applicable: "N",
          is_redemption: "N",
          report_full_amount: "N",
          report_full_amount_special_rc: "N",
          has_o_reporting_percent: "N",
          o_reporting_percent: null,
          visible_on_web: "N",
        },
        //Collapse
        sectionCollapse: {
          offer: true,
          offerconfig: true,
          offersplitconfig: true,
          otherOfferSettings: true,
          reportingSettings: true,
          offertype: true,
          outlet: true,
          dist_share: false,
        },
        RedemptionOutlet: {
          offer_redeem_at_online: "Y",
          offer_redeem_at_boxoffice: "Y",
          offer_redeem_at_concession: "N",
          offer_applicable_on: "gross_amount",
        },

        // Cinemas Screen SeatClass
        selectedCinemaScreenSeatClassList: [
          {
            cine_id: null,
            screen_id: null,
            sst_id: null,
            tt_id: null,
          },
        ],
        CinemasScreenSeatClassdataList: [
          {
            cinemasList: [],
            screenList: [],
            seatClassList: [],
          },
        ],
        // Cinemas Screen SeatClass

        OfferConfiguraion: {
          offer_applicable_on_all_cinemas: "N",
          selectedMovielist: [],
          pvms_start_show_time: "24:00",
          pvms_end_show_time: "23:59",
          avail_on_advanced_booking: "N",

          // selectedMovie: null,
          // md_id: null,
          SelectedCinemas: null,
          cine_id: null,
          SelectedScreen: null,
          screen_id: null,
          SelectedClass: null,
          sst_id: null,

          // offer_applicable_on_all_movies: "Y",
          // offer_applicable_on_all_day: "Y",
          // startDateTime: null,
          // endDateTime: null
        },
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
        fnbOfferObjTemp: {
          oc_buy_no_of_item: null,
          oc_buy_item_id: null,
          oc_buy_item_code: null,
          oc_fnb_at_price: null,
        },
        selectedOfferType: "fixedDiscount",
        buyAndGetFreeTickets: {
          oc_buy_no_of_ticket: null,
          oc_get_free_ticket: null,
          oc_min_ticket_price: null,
          oc_max_no_of_ticket_per_transaction: null,
          oc_combine_with_other_offers: "N",

          selectedCombineoffer: null,
        },
        buyTicketFnbFixedPrice: {
          oc_buy_no_of_ticket: null,
          oc_ticket_at_price: null,
          oc_min_ticket_price: null,
          oc_max_count_of_ticket: null,
          oc_combine_with_fnb: "N",
          Fnb_criteria: [
            {
              oc_buy_no_of_item: null,
              oc_buy_item_id: null,
              oc_buy_item_code: null,
              selectedFnbItem: "",
              oc_fnb_at_price: null,
            },
          ],
        },
        buyAndgetOffOnAnother: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: "",
          oc_discount_value_is_percentage: "Y",
          oc_offer_on_higher_amount: "N",
          oc_max_count_of_ticket: null,
          oc_max_discount_amount: null,
        },
        buyAndGetCombo: {
          offerApplicableAt: "boxOffice",
          boxOffice: {
            oc_buy_no_of_ticket: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            amount: null,
          },
          F_And_B: {
            oc_buy_item_count: null,
            oc_get_item_count: null,
            oc_buy_item_id: null,
            oc_get_item_id: null,
            // SelectedOnFnBItem: null,
            // SelectedFreeFnBItem: null,
            oc_is_combo_free: "N",
            oc_discount_value_is_percentage: "N",
            oc_discount_value: null,
          },
        },
        customCategoryOffers: {
          booking_user_category_id: null, // "student",
          institution_id: null,
          validate_doc_id: null,
          cco_min_ticket_amount: null,
          cco_max_discount_amount: null,
          cco_offer_value: null,
          cco_offer_value_is_percentage: "N",
          cco_instruction: null,
        },
        bankOffer: {
          bank_id: null,
          card_id: null,
          offerForDuration: "weekly",
          redemptionCount: null,
          maxRedemptionPerUser: null,
          bo_offer_value: null,
          bo_offer_value_is_percentage: null,
          bo_instruction: null,
        },
        promoCode: {
          pcs_send_email: "Y",
          pcs_send_sms: "N",
          booking_user_category_id: null,
          institution_id: null,
          multiplePromocode: "N",
          promoCodeList: [
            {
              promo_code: null,
              pcs_no_of_transaction: null,
              pcs_min_ticket_amount: null,
              pcs_max_discount_amount: null,
              pcs_offer_value: null,
              pcs_offer_value_is_percentage: "N",
            },
          ],
          pcs_instruction: null,
        },
        fnbItemDiscounts: [
          {
            fnb_item_code: "",
            fnb_item_offer: 0,
          },
        ],

        discountLists: [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
            canCombineOtherOffers: "N",
            selectedCombinedOffer: null,
          },
        ],
        // SAIF END
        TrueFalseCount: 0,
        offerContent: [],
        ContentLanguages: [],
        activeClass: 0,
        notempty: [false, false, false, false, false, false],
        uploadIndex: null,
        bannerUpload: false,
        imgUrl: null,
        filePath: null,
        filename: null,
      };
    },
    watch: {
      finalImagePath(newVal) {
        if (this.uploadImageType == 1) {
          this.offerContent[this.uploadIndex].offer_banner_image = newVal;
        } else {
          this.offerContent[this.uploadIndex].offer_poster_image = newVal;
        }
        this.$forceUpdate();
      },
      "sectionCollapse.dist_share"(newVal) {
        if (this.sectionCollapse.dist_share && !this.seatTypesList.length) {
          this.getAllScreenSeats();
        }
      },
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      showForeignMovieSection() {
        return CLIENT_NAMES_OBJ.showForeignMovieSection.includes(
          String(this.CLIENT_SETUP_NAME)
        );
      },
      showGrossNetButton() {
        return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
      },
      isEpix() {
        return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
      },
      booking_user_category() {
        if (
          this.promoCode.booking_user_category_id &&
          this.promoCode.booking_user_category_id.length > 0
        ) {
          return (
            this.promoCode.booking_user_category_id.filter((singleCategory) => {
              return String(singleCategory.buc_id) === "2";
            }).length > 0
          );
        } else {
          return false;
        }
      },
    },
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      let cinemaid =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;

      if (roleid == 3) {
        this.$router.go(-1);
      } else {
        this.getCinemasList();
        this.getActiveMovies();
        this.getFnBItems();
        this.getCustomerOffersCategories();
        this.getInstituesList();
        this.getBankList();
        // this.getBankCards();
        this.getVerificationList();
        this.getClientList();
        this.getTicketTypeList();
        this.getContentLangauge();
        this.getOfferGroupType();
        this.getMovieFormats();
      }
    },
    mounted() {},
    beforeDestroy() {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear();
        this.$validator.fields.items.forEach((field) => field.reset());
        this.$validator.fields.items.forEach((field) =>
          this.errors.remove(field)
        );
        this.$validator.reset();
      });
    },
    methods: {
      onChangeReporting(event, type) {
        if (type == "full" || type == "full_spcl") {
          this.OffersAndPromotion.o_reporting_percent = null;
          this.OffersAndPromotion.has_o_reporting_percent = "N";
        } else if (type == "specific") {
          this.OffersAndPromotion.report_full_amount_special_rc = "N";
          this.OffersAndPromotion.report_full_amount = "N";
        }
      },
      onchangeVisible(event, type) {
        console.log("check value=>", event);
        this.OffersAndPromotion.visible_on_web = event;
        console.log(
          "OffersAndPromotion.visible_on_web",
          this.OffersAndPromotion.visible_on_web
        );
      },
      addMoreDistShareValues() {
        this.distShareValues.push({
          seat_type_id: null,
          ticket_type_id: null,
          dist_value: null,
        });
      },
      removeDistValue(index) {
        this.distShareValues.splice(index, 1);
      },
      addFnbItemDiscountRow() {
        this.fnbItemDiscounts.push({ fnb_item_code: "", fnb_item_offer: 0 });
      },
      removeFnbItemDiscountRow(rowIndex) {
        this.fnbItemDiscounts.splice(rowIndex, 1);
      },
      onChangeChannelWise(event, index) {
        this.discountLists[index]["oc_min_fnb_price"] = 0;
      },
      onSelectBankOffer(event) {
        this.OffersAndPromotion.is_employee_offer = "N";
        if (event == "N") {
          this.OffersAndPromotion.bankDetails = {
            selectedBank: "",
            selectedCard: "",
            bank_id: null,
            card_type_ids: null,
          };
        }
      },
      onSelectBankv2(event, type) {
        if (type == "REMOVE") {
          this.OffersAndPromotion.bankDetails["bank_id"] = null;
          this.OffersAndPromotion.bankDetails["selectedBank"] = "";
          this.activeBankCardList = [];
        } else {
          this.OffersAndPromotion.bankDetails["bank_id"] = event["bank_id"];
        }
        this.getBankCards();
      },
      onSelectCardTypes(event, type) {
        if (type == "ADD") {
          console.log("onSelectCardTypes event", event);
          let IdsArray = this.OffersAndPromotion.bankDetails["card_type_ids"]
            ? this.OffersAndPromotion.bankDetails["card_type_ids"].split(", ")
            : [];
          IdsArray.push(event["card_id"]);
          if (IdsArray.length) {
            this.OffersAndPromotion.bankDetails[
              "card_type_ids"
            ] = IdsArray.join(", ");
          }
        } else if (type == "REMOVE") {
          let removeId = event["card_id"] || null;
          let tempArray =
            this.OffersAndPromotion.bankDetails["selectedCard"] &&
            this.OffersAndPromotion.bankDetails["selectedCard"].length
              ? this.OffersAndPromotion.bankDetails["selectedCard"].filter(
                  (y) => y.card_id != removeId
                )
              : [];
          let IdsArray = [];
          if (tempArray.length) {
            IdsArray = tempArray.map((x) => x.card_id);
          }
          if (IdsArray.length) {
            this.OffersAndPromotion.bankDetails[
              "card_type_ids"
            ] = IdsArray.join(", ");
          } else {
            this.OffersAndPromotion.bankDetails["card_type_ids"] = null;
          }
        }
      },
      checkOfferTypeAvailable(offerType) {
        if (this.OffersAndPromotion.is_employee_offer == "Y") {
          if (offerType == "fixedDiscount") {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
      onChangeCount(event, offerType, type) {
        let value = event.target.value;
        if (offerType == "buyTicketFnbFixedPrice") {
          if (type == "buy") {
            this.buyTicketFnbFixedPrice.oc_max_count_of_ticket = value;
          } else if (type == "max") {
            if (
              value &&
              this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket &&
              parseInt(this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket) >
                parseInt(value)
            ) {
              this.buyTicketFnbFixedPrice.oc_max_count_of_ticket = this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket;
              this.$toasted.show(
                "Max Limit Must be Greater or Equal to No. of Buy Tickets"
              );
              this.$forceUpdate();
            }
          }
        } else if (offerType == "buyAndgetOffOnAnother") {
          if (type == "buy") {
            this.buyAndgetOffOnAnother.oc_max_count_of_ticket = value;
          } else if (type == "max") {
            if (
              value &&
              this.buyAndgetOffOnAnother.oc_buy_no_of_ticket &&
              parseInt(this.buyAndgetOffOnAnother.oc_buy_no_of_ticket) >
                parseInt(value)
            ) {
              this.buyAndgetOffOnAnother.oc_max_count_of_ticket = this.buyAndgetOffOnAnother.oc_buy_no_of_ticket;
              this.$toasted.show(
                "Max Limit Must be Greater or Equal to No. of Buy Tickets"
              );
              this.$forceUpdate();
            }
          }
        }
      },
      selectFnbItemFixedOffer(event, index, type) {
        if (type == "Add") {
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_id =
            event.item_id;
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_code =
            event.item_code;
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].selectedFnbItem = {
            item_id: event.item_id,
            item_name: event.item_name,
            item_code: event.item_code,
          };
        } else if (type == "Remove") {
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_id = null;
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].oc_buy_item_code = "";
          this.buyTicketFnbFixedPrice.Fnb_criteria[index].selectedFnbItem = "";
        }
      },
      onChangeDiscountValue(event, index) {
        let value = event.target.value || 0;
        this.discountLists[index].oc_max_discount_amount = value;
      },
      addFnbCriteria() {
        let fnbObj = {
          oc_buy_no_of_item: null,
          oc_buy_item_id: null,
          oc_buy_item_code: null,
          selectedFnbItem: "",
          oc_fnb_at_price: null,
        };
        this.buyTicketFnbFixedPrice.Fnb_criteria.push(fnbObj);
      },
      removeFnbCriteria(index) {
        this.buyTicketFnbFixedPrice.Fnb_criteria.splice(index, 1);
      },
      setModalData(height, width, contentIndex = null, type = 1) {
        this.uploadImageType = type;
        this.bannerUpload = false;
        this.$forceUpdate();
        this.set_height = height;
        this.set_width = width;
        this.uploadIndex = contentIndex;
        this.showModal = !this.showModal;
      },
      onChangeTranslationInput(event, content, contentIndex, item) {
        this.CheckEmptyContent(content, contentIndex);
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      onChangeText(event, type) {
        this.offerContent.map((x) => {
          if (x.langauge.toLowerCase() == "english") {
            if (type == "name") {
              x.offer_title = event.target.value;
            } else if (type == "desc") {
              x.offer_description = event.target.value;
            }
          }
        });
      },
      CheckEmptyContent: function(Content, index) {
        if (Content.langauge.toLowerCase() !== "english") {
          if (Content.offer_title) {
            this.notempty[index] = true;
          } else {
            this.notempty[index] = false;
          }
        }
      },
      getOfferGroupType() {
        let payload = {
          status: "Active",
        };
        MarketingService.GetAllOfferGroupType(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.offerGroupType = [...data.Records];
              } else {
                console.log("Error:", data.message);
                this.$toasted.show(data.message);
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getMovieFormats: function() {
        let payload = {
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.movieFormats = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch(this._CatchError);
      },
      getContentLangauge: function() {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers();
          })
          .catch((error) => {
            console.log("Catch Error :", error);
          });
      },
      makeLangContainers: function() {
        this.ContentLanguages.map((x) => {
          let Obj = {
            ...x,
            offer_title: "",
            offer_description: "",
            offer_banner_image: "",
            offer_poster_image: "",
          };
          this.offerContent.push(Obj);
          console.log("this.offerContent", this.offerContent);
        });
      },
      onChangeOfferType(event) {
        console.log("event", event);
        if (event == "buyAndGetFreeTickets") {
          this.RedemptionOutlet.offer_redeem_at_concession = "N";
        } else if (event == "fixedPriceTicketFnb") {
          this.RedemptionOutlet.offer_redeem_at_concession = "N";
        } else if (event == "buyAndgetOffOnAnother") {
          this.RedemptionOutlet.offer_redeem_at_concession = "N";
        } else if (event == "fnbItemDiscounts") {
          this.RedemptionOutlet.offer_redeem_at_boxoffice = "N";
          this.RedemptionOutlet.offer_redeem_at_concession = "Y";
        }
        this.discountLists = [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
            canCombineOtherOffers: "N",
            selectedCombinedOffer: null,
          },
        ];
      },
      onSelectBank: function(data) {
        // console.log("data :>> ", data);
        this.bankOffer.bank_id = data.bank_id;
        this.getBankCards();
      },
      selectTicketType(tt, index) {
        console.log("index :>> ", index);
        this.selectedCinemaScreenSeatClassList[index].tt_id = tt.tt_id;
      },
      // Saif
      onChangeWeekdays: function(event, keyname) {
        this.TrueFalseCount = 0;

        if (keyname !== "selectAll") {
          this.weekDays["selectAll"] = false;
          this.weekDays[keyname] = event;
        }

        let len = Object.keys(this.weekDays).length;
        if (keyname === "selectAll" && event) {
          Object.keys(this.weekDays).map((x) => {
            x !== "selectAll" ? (this.weekDays[x] = true) : "";
          });
        } else if (keyname === "selectAll" && !event) {
          Object.keys(this.weekDays).map((x) => {
            x !== "selectAll" ? (this.weekDays[x] = false) : "";
          });
        } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
          this.weekDays["selectAll"] = false;
        }

        Object.keys(this.weekDays).map((x) => {
          if (x != "selectAll") {
            if (this.weekDays[x] === false) {
              this.TrueFalseCount++;
            }
          }
        });

        // if (
        //   Object.keys(this.weekDays).filter(x => this.weekDays[x]).length ===
        //   len - 1
        // ) {
        //   this.weekDays["selectAll"] = true;
        // }
      },
      async getTicketTypeList() {
        try {
          this.TicketTypes = [];
          let body = {
            tableName: "ms_ticket_type",
          };
          const { data } = await MasterService.GetActiveList(body);

          if (data && data.status && data.Records.length > 0) {
            this.TicketTypes = data.Records;
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        } catch (error) {
          console.error(error);
        }
      },
      getCinemasList: function() {
        this.cinemasList = [];
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              // data.Records.length > 0 ? (this.cinemasList = data.Records) : "";
              if (data.Records.length > 0) {
                this.cinemasList = data.Records;
                this.OffersAndPromotion.pg_promo_code = data.Records.map(
                  (c) => ({
                    pg_promo_code: "",
                    cine_id: c.cine_id,
                    cine_name: c.cine_name,
                  })
                );
                // this.CinemasScreenSeatClassdataList[0].cinemasList = data.Records;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getScreenList: function(cinema_id, Indexx) {
        // this.screenList = [];
        // this.seatClassList = [];
        // this.OfferConfiguraion.screen_id = null;
        // this.OfferConfiguraion.sst_id = null;

        this.CinemasScreenSeatClassdataList[Indexx].screenList = [];
        this.selectedCinemaScreenSeatClassList[Indexx].screen_id = null;

        this.CinemasScreenSeatClassdataList[Indexx].seatClassList = [];
        this.selectedCinemaScreenSeatClassList[Indexx].sst_id = null;

        if (cinema_id) {
          let payload = {
            tableName: "screens",
            screen_is_active: "Y",
            cinema_id,
          };
          MasterService.GetActiveList(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (data.Records.length > 0) {
                  // this.screenList = data.Records
                  this.CinemasScreenSeatClassdataList[Indexx].screenList =
                    data.Records;
                }
              } else {
                this.$toasted.show(data.message || this.AdminError);
              }
            })
            .catch(this._CatchError);
        }
      },
      getSeatClassList: function(screen_id, Indexx) {
        // this.seatClassList = [];
        // this.OfferConfiguraion.sst_id = null;

        this.CinemasScreenSeatClassdataList[Indexx].seatClassList = [];
        this.selectedCinemaScreenSeatClassList[Indexx].sst_id = null;

        if (screen_id) {
          let payload = {
            tableName: "screen_seat_type",
            screen_id: screen_id,
            sst_is_active: "Y",
          };
          MasterService.GetActiveList(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (data.Records.length > 0) {
                  // this.seatClassList = data.Records;
                  this.CinemasScreenSeatClassdataList[Indexx].seatClassList =
                    data.Records;
                }
              } else {
                this.$toasted.show(data.message || this.AdminError);
              }
            })
            .catch(this._CatchError);
        }
      },
      getClientList() {
        ClientService.GetAllClients({})
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.clientList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getActiveMovies: function() {
        this.movieList = [];
        let payload = {
          movieversions: "Y",
        };
        MovieService.GetActiveMoviesWithFormat(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              data.Records.length > 0 ? (this.movieList = data.Records) : "";
            } else {
              // Show Error Message
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getFnBItems: function() {
        MarketingService.GetAllFNBItems()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              // console.log("data.Records :>> ", data.Records);
              data.Records.length > 0 ? (this.fnbItems = data.Records) : "";
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getCustomerOffersCategories: function() {
        MarketingService.GetCustomerCategories()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              if (data.Records.length > 0) {
                // console.log("data.Records[0] :", data.Records[0]);
                this.customerOffersCategories = data.Records;
                this.customCategoryOffers.booking_user_category_id =
                  data.Records[0].buc_id;
              }
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getInstituesList: function() {
        MarketingService.GetActiveInstitites()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              if (data.Records.length > 0) {
                this.institutionList = data.Records;
              }
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getBankList: function() {
        MarketingService.GetActiveBanks()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              if (data.Records.length > 0) {
                this.activeBankList = data.Records;
              }
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getBankCards: function() {
        this.activeBankCardList = [];
        let bankId = this.OffersAndPromotion.bankDetails["bank_id"] || null;
        if (bankId) {
          MarketingService.GetActiveBanksCards(
            this.OffersAndPromotion.bankDetails["bank_id"]
          )
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records) {
                if (data.Records.length > 0) {
                  this.activeBankCardList = data.Records;
                }
              } else {
                this.$toasted.show(
                  data.message || "Opps! Something went wrong"
                );
              }
            })
            .catch(this._CatchError);
        } else {
          this.activeBankCardList = [];
        }
      },
      getVerificationList: function() {
        MarketingService.GetVerificationList()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) this.verificationList = data.Records;
            } else this.$toasted.show(data.message || this.AdminError);
          })
          .catch(this._CatchError);
      },
      showError: function(message) {
        this.$toasted.show(message, {
          duration: null,
          action: {
            text: "x",
            onClick: (e, toastObject) => toastObject.goAway(0),
          },
        });
      },
      convertTime(date, time) {
        const d = moment(date).format("YYYY-MM-DD");
        const newdate = moment(d + " " + time).format("YYYY-MM-DD HH:mm");
        return newdate;
      },
      validateOfferData(showToastMsg = true) {
        let errorCount = 0;
        let errorMsg = ``;
        if (this.selectedOfferType == "fixedPriceTicketFnb") {
          if (
            isNaN(this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket) ||
            !this.buyTicketFnbFixedPrice.oc_buy_no_of_ticket
          ) {
            errorCount++;
            errorMsg = `Please Enter Buy No. Of Ticket`;
          } else if (
            isNaN(this.buyTicketFnbFixedPrice.oc_ticket_at_price) ||
            !this.buyTicketFnbFixedPrice.oc_ticket_at_price
          ) {
            errorCount++;
            errorMsg = `Please Enter Flat Ticket Price`;
          } else {
            if (this.buyTicketFnbFixedPrice.oc_combine_with_fnb == "Y") {
              this.buyTicketFnbFixedPrice.Fnb_criteria.map((x) => {
                if (isNaN(x.oc_buy_no_of_item) || !x.oc_buy_no_of_item) {
                  errorCount++;
                  errorMsg = `Please Enter Buy No. Of Items`;
                } else if (isNaN(x.oc_fnb_at_price) || !x.oc_fnb_at_price) {
                  errorCount++;
                  errorMsg = `Please Enter Flat Item Price`;
                } else if (!x.oc_buy_item_code) {
                  errorCount++;
                  errorMsg = `Please Select Item`;
                }
              });
            }
          }
        }

        if (
          this.OffersAndPromotion.is_bank_offer == "Y" &&
          !this.OffersAndPromotion.bankDetails["bank_id"]
        ) {
          errorCount++;
          errorMsg = `Please Select Bank`;
        }

        if (errorCount > 0) {
          if (showToastMsg) {
            this.$toasted.show(errorMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      OnFinalSubmit: function(flag) {
        this.submitted = true;

        if (
          this.OffersAndPromotion.offer_start_date_time >
          this.OffersAndPromotion.offer_end_date_time
        ) {
          return this.$toasted.show("Please Enter Proper Dates");
        } else {
          console.log(
            "this.OffersAndPromotion.offer_start_date_time",
            this.OffersAndPromotion.offer_start_date_time
          );
          if (
            this.OffersAndPromotion.startTime2 &&
            moment(this.OffersAndPromotion.startTime2, "HH:mm").isValid()
          ) {
            this.OffersAndPromotion.offer_start_date_time = this.convertTime(
              this.OffersAndPromotion.offer_start_date_time,
              this.OffersAndPromotion.startTime2
            );
          }
          if (
            this.OffersAndPromotion.endTime2 &&
            moment(this.OffersAndPromotion.endTime2, "HH:mm").isValid()
          ) {
            this.OffersAndPromotion.offer_end_date_time = this.convertTime(
              this.OffersAndPromotion.offer_end_date_time,
              this.OffersAndPromotion.endTime2
            );
          }
        }

        if (
          this.selectedOfferType == "buyAndGetFreeTickets" &&
          this.buyAndGetFreeTickets.oc_get_free_ticket >
            this.buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
        ) {
          return this.$toasted.show(
            "Maximum Number of free tickets Must be greater and Offer Free ticket"
          );
        }

        if (
          this.offerMovies.is_applicable == "movies_not_applicable" &&
          !this.selectedMovieFormats.length
        ) {
          return this.$toasted.show(
            "Please select atleast one applicable movie format"
          );
        }

        if (!this.validateOfferData()) {
          return;
        }
        //  OffersAndPromotion: {
        //   offer_title: "",
        //   offer_code: "PO-" + generateRandomCode(8),
        //   offer_start_date_time: Start_Date,
        //   offer_end_date_time: End_date,
        //   offerValidFor: "fAndb"
        // };

        // if (
        //   !this.OffersAndPromotion.offer_title ||
        //   String(this.OffersAndPromotion.offer_title).length === 0
        // ) {
        //   return;
        // } else if (
        //   !this.OffersAndPromotion.offer_code ||
        //   String(this.OffersAndPromotion.offer_code).length === 0
        // ) {
        //   this.showError("Please enter offer code");
        // } else {
        // OfferConfiguraion: {
        // offer_applicable_on_all_cinemas: "N",
        // selectedMovielist: [],
        // pvms_start_show_time: "24:00:00",
        // pvms_end_show_time: "23:59:59",

        this.$validator.validate().then((valid) => {
          if (this.TrueFalseCount == 7) {
            return;
          }
          // if (
          //   !this.OffersAndPromotion.selectedClient ||
          //   this.OffersAndPromotion.selectedClient.length == 0
          // ) {
          //   return;
          // }
          if (
            (this.selectedOfferType == "buyAndGetCombo" &&
              this.buyAndGetCombo.offerApplicableAt === "fAndb" &&
              this.buyAndGetCombo.F_And_B.oc_buy_item_id == null) ||
            (this.selectedOfferType == "buyAndGetCombo" &&
              this.buyAndGetCombo.offerApplicableAt === "fAndb" &&
              this.buyAndGetCombo.F_And_B.oc_get_item_id == null) ||
            (this.selectedOfferType == "buyAndGetCombo" &&
              this.buyAndGetCombo.offerApplicableAt === "boxOffice" &&
              this.buyAndGetCombo.boxOffice.oc_get_item_id == null)
          ) {
            return;
          }
          if (
            (this.selectedOfferType == "customCategoryOffers" &&
              String(this.customCategoryOffers.booking_user_category_id) ===
                String(2) &&
              this.customCategoryOffers.institution_id == null) ||
            (this.selectedOfferType == "customCategoryOffers" &&
              String(this.customCategoryOffers.booking_user_category_id) ===
                String(4) &&
              this.customCategoryOffers.institution_id == null) ||
            (this.selectedOfferType == "customCategoryOffers" &&
              this.customCategoryOffers.validate_doc_id == null)
          ) {
            return;
          }
          if (
            (this.selectedOfferType == "bankOffer" &&
              this.bankOffer.bank_id == null) ||
            (this.selectedOfferType == "bankOffer" &&
              this.bankOffer.card_id == null)
          ) {
            return;
          }
          if (
            (this.selectedOfferType == "promoCode" &&
              this.promoCode.booking_user_category_id == null) ||
            (this.selectedOfferType == "promoCode" &&
              this.promoCode.institution_id == null)
          ) {
            return;
          }

          if (
            this.selectedOfferType == "fnbItemDiscounts" &&
            !this.fnbItemDiscounts.length
          ) {
            this.$toasted.show("Fnb Item Offer missing");
            return;
          }
          if (valid) {
            this.OfferConfiguraion["pvms_start_show_time"] = this
              .OfferConfiguraion["pvms_start_show_time"]
              ? moment(
                  this.OfferConfiguraion["pvms_start_show_time"],
                  "HH:mm"
                ).format("HH:mm:ss")
              : null;
            this.OfferConfiguraion["pvms_end_show_time"] = this
              .OfferConfiguraion["pvms_end_show_time"]
              ? moment(
                  this.OfferConfiguraion["pvms_end_show_time"],
                  "HH:mm"
                ).format("HH:mm:ss")
              : null;
            this.btenable = true;
            if (
              this.OfferConfiguraion.offer_applicable_on_all_cinemas === "Y"
            ) {
              this.selectedCinemaScreenSeatClassList.map(
                (item) =>
                  (item.tt_id =
                    item.tt_id && item.tt_id.hasOwnProperty("tt_id")
                      ? item.tt_id.tt_id
                      : null)
              );
            }
            let payload = {
              ...this.OffersAndPromotion,
              ...this.RedemptionOutlet,
              weekDays: this.weekDays,
              ...this.OfferConfiguraion,
              movie_is_applicable:
                this.offerMovies.is_applicable == "movies_applicable"
                  ? "Y"
                  : "N",
              movie_formats: this.selectedMovieFormats.length
                ? this.selectedMovieFormats
                    .map((mfObj) => {
                      return mfObj.mf_id;
                    })
                    .toString()
                : "",
              CinemaScreenSeatClassList: this.selectedCinemaScreenSeatClassList,
              offerType: this.selectedOfferType,
              buyAndGetFreeTickets: this.buyAndGetFreeTickets,
              discountList: this.discountLists,
              buyAndGetCombo: this.buyAndGetCombo,
              buyTicketFnbFixedPrice: this.buyTicketFnbFixedPrice,
              buyAndgetOffOnAnother: this.buyAndgetOffOnAnother,
              customCategoryOffers: this.customCategoryOffers,
              bankOffer: this.bankOffer,
              promoCode: this.promoCode,
              OfferContent: this.offerContent,
            };
            payload.pg_promo_code = JSON.stringify(payload.pg_promo_code);
            payload["offer_group_type_id"] =
              this.selectedOfferGroupType.ogt_id || 1;

            if (
              this.distShareValues.length &&
              this.distShareValues[0].seat_type_id
            ) {
              payload["distShareData"] = [];
              this.distShareValues.map((distObj) => {
                distObj.seat_type_id.map((seatObj) => {
                  payload["distShareData"].push({
                    sst_id: seatObj.sst_id,
                    screen_id: seatObj.screen_id,
                    tt_id:
                      distObj.ticket_type_id && distObj.ticket_type_id.length
                        ? distObj.ticket_type_id
                            .map((ticketObj) => {
                              return ticketObj.tt_id;
                            })
                            .toString()
                        : null,
                    distValue: distObj.dist_value,
                  });
                });
              });
            }

            if (this.selectedOfferType == "fnbItemDiscounts") {
              this.fnbItemDiscounts = this.fnbItemDiscounts.filter(
                (fnbItemObj) => {
                  return (
                    fnbItemObj.fnb_item_code &&
                    fnbItemObj.fnb_item_code.hasOwnProperty("item_code") &&
                    fnbItemObj.fnb_item_offer
                  );
                }
              );
              payload["fnbItemDiscounts"] = this.fnbItemDiscounts.map(
                (fnbItem) => ({
                  pv_fnb_item_code: fnbItem.fnb_item_code.item_code,
                  pv_fnb_item_offer: fnbItem.fnb_item_offer,
                })
              );
            }

            console.log({
              payload: { ...payload },
            });

            MarketingService.AddPromotionAndOffers(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  // data.Records.length > 0
                  this.$toasted.show(data.message || this.AdminError);
                  this.resetHandler();
                  if (flag) {
                    this.$router.push({
                      path: "/marketing/promotions-and-offers",
                    });
                  }
                } else {
                  // Show Error Message
                  this.$toasted.show(data.message || this.AdminError);
                  // this.showError(data.message || this.AdminError);
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                this.btenable = false;
              });
          }
        });
        // }
      },
      resetHandler: function() {
        this.OffersAndPromotion = {
          offer_title: "",
          offer_code: "PO-" + generateRandomCode(8),
          offer_description_text: "",
          offer_start_date_time: Start_Date,
          offer_end_date_time: End_date,
          offerValidFor: "fAndb",
          selectedClient: [],
          client_id: null,
          share_value: null,
          share_is_percentage: "Y",
          is_employee_offer: "N",
          is_bank_offer: "N",
          startTime2: "",
          endTime2: "",
          bankDetails: {
            selectedBank: "",
            selectedCard: "",
            bank_id: null,
            card_type_ids: null,
          },
        };
        this.RedemptionOutlet = {
          offer_redeem_at_online: "Y",
          offer_redeem_at_boxoffice: "Y",
          offer_redeem_at_concession: "N",
          offer_applicable_on: "gross_amount",
        };

        // Cinemas Screen SeatClass
        this.selectedCinemaScreenSeatClassList = [
          {
            cine_id: null,
            screen_id: null,
            sst_id: null,
            tt_id: null,
          },
        ];
        this.CinemasScreenSeatClassdataList = [
          {
            cinemasList: [],
            screenList: [],
            seatClassList: [],
          },
        ];
        // Cinemas Screen SeatClass

        this.OfferConfiguraion = {
          offer_applicable_on_all_cinemas: "N",
          selectedMovielist: [],
          pvms_start_show_time: "24:00",
          pvms_end_show_time: "23:59",

          // selectedMovie: null,
          // md_id: null,
          SelectedCinemas: null,
          cine_id: null,
          SelectedScreen: null,
          screen_id: null,
          SelectedClass: null,
          sst_id: null,

          // offer_applicable_on_all_movies: "Y",
          // offer_applicable_on_all_day: "Y",
          // startDateTime: null,
          // endDateTime: null
        };
        this.weekDays = {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        };

        this.selectedOfferType = "buyAndGetFreeTickets";
        this.buyAndGetFreeTickets = {
          oc_buy_no_of_ticket: null,
          oc_get_free_ticket: null,
          oc_min_ticket_price: null,
          oc_max_no_of_ticket_per_transaction: null,
          oc_combine_with_other_offers: "N",

          selectedCombineoffer: null,
        };

        this.buyTicketFnbFixedPrice = {
          oc_buy_no_of_ticket: null,
          oc_ticket_at_price: null,
          oc_max_count_of_ticket: null,
          oc_min_ticket_price: null,
          oc_combine_with_fnb: "N",
          Fnb_criteria: [
            {
              oc_buy_no_of_item: null,
              oc_buy_item_id: null,
              oc_buy_item_code: null,
              selectedFnbItem: "",
              oc_fnb_at_price: null,
            },
          ],
        };

        (this.buyAndgetOffOnAnother = {
          oc_buy_no_of_ticket: null,
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_offer_on_higher_amount: "N",
          oc_max_count_of_ticket: null,
          oc_max_discount_amount: null,
        }),
          (this.buyAndGetCombo = {
            offerApplicableAt: "boxOffice",
            boxOffice: {
              oc_buy_no_of_ticket: null,
              oc_get_item_id: null,
              oc_is_combo_free: "N",
              oc_discount_value: null,
              oc_discount_value_is_percentage: "N",
              amount: null,
            },
            F_And_B: {
              oc_buy_item_count: null,
              oc_get_item_count: null,
              oc_buy_item_id: null,
              oc_get_item_id: null,
              // SelectedOnFnBItem: null,
              // SelectedFreeFnBItem: null,
              oc_is_combo_free: "N",
              oc_discount_value_is_percentage: "N",
              oc_discount_value: null,
            },
          });
        this.customCategoryOffers = {
          booking_user_category_id: null, // "student",
          institution_id: null,
          validate_doc_id: null,
          cco_min_ticket_amount: null,
          cco_max_discount_amount: null,
          cco_offer_value: null,
          cco_offer_value_is_percentage: "N",
          cco_instruction: null,
        };
        this.bankOffer = {
          bank_id: null,
          card_id: null,
          offerForDuration: "weekly",
          redemptionCount: null,
          maxRedemptionPerUser: null,
          bo_offer_value: null,
          bo_offer_value_is_percentage: null,
          bo_instruction: null,
        };
        this.promoCode = {
          pcs_send_email: "Y",
          pcs_send_sms: "N",
          booking_user_category_id: null,
          institution_id: null,
          multiplePromocode: "N",
          promoCodeList: [
            {
              promo_code: null,
              pcs_no_of_transaction: null,
              pcs_min_ticket_amount: null,
              pcs_max_discount_amount: null,
              pcs_offer_value: null,
              pcs_offer_value_is_percentage: "N",
            },
          ],
          pcs_instruction: null,
        };

        this.discountLists = [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
            canCombineOtherOffers: "N",
            selectedCombinedOffer: null,
          },
        ];
      },
      onSelectEmployeeDiscount(event) {
        console.log("onSelectEmployeeDiscount event", event);
        this.selectedOfferType = "fixedDiscount";

        (this.RedemptionOutlet = {
          offer_redeem_at_online: "N",
          offer_redeem_at_boxoffice: "Y",
          offer_redeem_at_concession: "Y",
          offer_applicable_on: "gross_amount",
        }),
          (this.buyAndGetFreeTickets = {
            oc_buy_no_of_ticket: null,
            oc_get_free_ticket: null,
            oc_min_ticket_price: null,
            oc_max_no_of_ticket_per_transaction: null,
            oc_combine_with_other_offers: "N",

            selectedCombineoffer: null,
          });

        this.buyTicketFnbFixedPrice = {
          oc_buy_no_of_ticket: null,
          oc_ticket_at_price: null,
          oc_max_count_of_ticket: null,
          oc_min_ticket_price: null,
          oc_combine_with_fnb: "N",
          Fnb_criteria: [
            {
              oc_buy_no_of_item: null,
              oc_buy_item_id: null,
              oc_buy_item_code: null,
              selectedFnbItem: "",
              oc_fnb_at_price: null,
            },
          ],
        };

        this.buyAndgetOffOnAnother = {
          oc_buy_no_of_ticket: null,
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_offer_on_higher_amount: "N",
          oc_max_count_of_ticket: null,
          oc_max_discount_amount: null,
        };
        this.buyAndGetCombo = {
          offerApplicableAt: "boxOffice",
          boxOffice: {
            oc_buy_no_of_ticket: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            amount: null,
          },
          F_And_B: {
            oc_buy_item_count: null,
            oc_get_item_count: null,
            oc_buy_item_id: null,
            oc_get_item_id: null,
            // SelectedOnFnBItem: null,
            // SelectedFreeFnBItem: null,
            oc_is_combo_free: "N",
            oc_discount_value_is_percentage: "N",
            oc_discount_value: null,
          },
        };
        this.customCategoryOffers = {
          booking_user_category_id: null, // "student",
          institution_id: null,
          validate_doc_id: null,
          cco_min_ticket_amount: null,
          cco_max_discount_amount: null,
          cco_offer_value: null,
          cco_offer_value_is_percentage: "N",
          cco_instruction: null,
        };
        this.bankOffer = {
          bank_id: null,
          card_id: null,
          offerForDuration: "weekly",
          redemptionCount: null,
          maxRedemptionPerUser: null,
          bo_offer_value: null,
          bo_offer_value_is_percentage: null,
          bo_instruction: null,
        };
        this.promoCode = {
          pcs_send_email: "Y",
          pcs_send_sms: "N",
          booking_user_category_id: null,
          institution_id: null,
          multiplePromocode: "N",
          promoCodeList: [
            {
              promo_code: null,
              pcs_no_of_transaction: null,
              pcs_min_ticket_amount: null,
              pcs_max_discount_amount: null,
              pcs_offer_value: null,
              pcs_offer_value_is_percentage: "N",
            },
          ],
          pcs_instruction: null,
        };
        this.discountLists = [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
            canCombineOtherOffers: "N",
            selectedCombinedOffer: null,
          },
        ];
      },
      onSelectClient: function(client) {
        this.OffersAndPromotion.client_id = client.client_id;
      },
      addMoreCinemasScreenSeatClass: function() {
        this.selectedCinemaScreenSeatClassList.push({
          cine_id: null,
          screen_id: null,
          sst_id: null,
          tt_id: null,
        });
        this.CinemasScreenSeatClassdataList.push({
          cinemasList: this.cinemasList,
          screenList: [],
          seatClassList: [],
        });
      },
      removeCinemasScreenSeatClass: function(index) {
        this.selectedCinemaScreenSeatClassList.splice(index, 1);
        this.CinemasScreenSeatClassdataList.splice(index, 1);
      },
      // Saif End
      addDiscount: function() {
        this.discountLists.push({
          oc_buy_no_of_ticket: "",
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
          oc_min_ticket_price: 0,
          oc_min_fnb_price: 0,
          min_amount_channel_wise: "N",
          canCombineOtherOffers: "N",
          selectedCombinedOffer: null,
        });
      },
      addMorePromo: function() {
        this.promoCode.promoCodeList.push({
          promo_code: null,
          pcs_no_of_transaction: null,
          pcs_min_ticket_amount: null,
          pcs_max_discount_amount: null,
          pcs_offer_value: null,
          pcs_offer_value_is_percentage: "N",
        });
      },
      removePromo: function(index) {
        this.promoCode.promoCodeList.splice(index, 1);
      },
      removeDiscount: function(index) {
        this.discountLists.splice(index, 1);
      },
      onChangeCustomerCategory: function() {
        this.customCategoryOffers.institution_id = null;
      },
      onChangeMultipleHandler: function(event) {
        if (event === "N") {
          this.promoCode.promoCodeList = this.promoCode.promoCodeList.slice(
            0,
            1
          );
        }
      },
      getAllScreenSeats: async function() {
        try {
          const response = await MarketingService.getCinemaScreenSeats();
          const { data } = response;
          if (data.status && data.Records.length) {
            this.seatTypesList = data.Records;
            if (this.promoDistShareValues.length) {
              this.distShareValues = [];
              this.promoDistShareValues.map((shareValuesObj) => {
                let distIndex = this.distShareValues.findIndex((distObj) => {
                  return distObj.dist_value == shareValuesObj.pvds_dist_value;
                });
                if (distIndex < 0) {
                  let ticketFilteredData = [];
                  if (shareValuesObj.pvds_ticket_type_id) {
                    let ticketData = String(
                      shareValuesObj.pvds_ticket_type_id
                    ).split(",");
                    ticketFilteredData = this.TicketTypes.filter(
                      (ticketObj) => {
                        return ticketData.includes(String(ticketObj.tt_id));
                      }
                    );
                  }
                  let obj = {
                    seat_type_id: [
                      {
                        screen_id: shareValuesObj.pvds_screen_id,
                        sst_id: shareValuesObj.pvds_seat_type_id,
                        sst_seat_type: shareValuesObj.sst_seat_type,
                        screen_name: shareValuesObj.screen_name,
                      },
                    ],
                    ticket_type_id: ticketFilteredData.length
                      ? ticketFilteredData
                      : [],
                    dist_value: shareValuesObj.pvds_dist_value,
                  };
                  this.distShareValues.push(obj);
                } else {
                  this.distShareValues[distIndex]["seat_type_id"].push({
                    screen_id: shareValuesObj.pvds_screen_id,
                    sst_id: shareValuesObj.pvds_seat_type_id,
                    sst_seat_type: shareValuesObj.sst_seat_type,
                    screen_name: shareValuesObj.screen_name,
                  });
                }
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
    },
  };
</script>

<style>
  .select-offers-list {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .select-offers-list li {
    padding-top: 15px;
  }

  .timepicker li,
  .timepicker li .actived {
    list-style: none !important;
    padding-top: 0 !important;
    border-bottom: none !important;
  }

  .select-offers-list li:not(:last-child) {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--lightgrey);
  }

  .offer-title {
    display: flex;
  }

  .custom-date .btn-clearDate {
    right: 40px !important;
  }

  .new-border {
    border: 2px solid #b1b4b8;
  }

  label {
    color: black !important;
  }

  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }

  .internal-border {
    border: 1px solid var(--blue);
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }

  .fs {
    font-size: 17px;
  }

  .back {
    background-color: #fff;
  }

  .mar {
    margin-left: 30px;
  }

  .back_white {
    background-color: white;
    border: 2px solid #b1b4b8;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/addPromotionsAndOffers.vue